export default function Article() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="231.999" height="139.681" viewBox="0 0 231.999 139.681">
      <g id="Group_33150" data-name="Group 33150" transform="translate(-137.001 -648)">
        <g id="Group_15955" data-name="Group 15955" transform="translate(114.864 613.676)">
          <g id="Background_Complete" data-name="Background Complete" transform="translate(27.671 34.324)">
            <g id="Group_15019" data-name="Group 15019" transform="translate(187.064 9.01)">
              <g id="Group_15005" data-name="Group 15005" transform="translate(1.146)">
                <g id="Group_15004" data-name="Group 15004">
                  <g id="Group_15003" data-name="Group 15003">
                    <rect id="Rectangle_18357" data-name="Rectangle 18357" width="34.455" height="57.033" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15008" data-name="Group 15008">
                <g id="Group_15007" data-name="Group 15007">
                  <g id="Group_15006" data-name="Group 15006">
                    <rect id="Rectangle_18358" data-name="Rectangle 18358" width="34.455" height="57.033" fill="#ebebeb" />
                  </g>
                </g>
              </g>
              <g id="Group_15011" data-name="Group 15011" transform="translate(1.467 1.157)">
                <g id="Group_15010" data-name="Group 15010">
                  <g id="Group_15009" data-name="Group 15009">
                    <rect id="Rectangle_18359" data-name="Rectangle 18359" width="31.521" height="54.72" fill="#fafafa" />
                  </g>
                </g>
              </g>
              <g id="Group_15018" data-name="Group 15018" transform="translate(7.468 8.267)">
                <g id="Group_15014" data-name="Group 15014" transform="translate(0)">
                  <g id="Group_15013" data-name="Group 15013">
                    <g id="Group_15012" data-name="Group 15012">
                      <rect id="Rectangle_18360" data-name="Rectangle 18360" width="19.383" height="40.499" fill="#ebebeb" />
                    </g>
                  </g>
                </g>
                <g id="Group_15017" data-name="Group 15017" transform="translate(0 11.227)">
                  <g id="Group_15016" data-name="Group 15016">
                    <g id="Group_15015" data-name="Group 15015">
                      <path id="Path_20171" data-name="Path 20171" d="M630.723,135.973c-.045-3.783,3.357-7.476,7.1-8,1.786-.252,3.684.1,5.354-.582,2.979-1.222,3.927-5.18,6.926-6.355l.137,29.272h-19.52Z" transform="translate(-630.723 -121.032)" fill="#e0e0e0" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Group_15124" data-name="Group 15124" transform="translate(30.117)">
              <g id="Group_15029" data-name="Group 15029" transform="translate(1.608 0.007)">
                <g id="Group_15028" data-name="Group 15028">
                  <g id="Group_15027" data-name="Group 15027">
                    <g id="Group_15026" data-name="Group 15026">
                      <g id="Group_15025" data-name="Group 15025">
                        <g id="Group_15024" data-name="Group 15024">
                          <g id="Group_15023" data-name="Group 15023">
                            <g id="Group_15022" data-name="Group 15022">
                              <g id="Group_15021" data-name="Group 15021">
                                <g id="Group_15020" data-name="Group 15020">
                                  <rect id="Rectangle_18361" data-name="Rectangle 18361" width="23.628" height="24.63" fill="#e0e0e0" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15048" data-name="Group 15048">
                <g id="Group_15038" data-name="Group 15038" transform="translate(0.007 0.007)">
                  <g id="Group_15037" data-name="Group 15037">
                    <g id="Group_15036" data-name="Group 15036">
                      <g id="Group_15035" data-name="Group 15035">
                        <g id="Group_15034" data-name="Group 15034">
                          <g id="Group_15033" data-name="Group 15033">
                            <g id="Group_15032" data-name="Group 15032">
                              <g id="Group_15031" data-name="Group 15031">
                                <g id="Group_15030" data-name="Group 15030">
                                  <rect id="Rectangle_18362" data-name="Rectangle 18362" width="23.628" height="24.63" fill="#fafafa" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15047" data-name="Group 15047">
                  <g id="Group_15046" data-name="Group 15046">
                    <g id="Group_15045" data-name="Group 15045">
                      <g id="Group_15044" data-name="Group 15044">
                        <g id="Group_15043" data-name="Group 15043">
                          <g id="Group_15042" data-name="Group 15042">
                            <g id="Group_15041" data-name="Group 15041">
                              <g id="Group_15040" data-name="Group 15040">
                                <g id="Group_15039" data-name="Group 15039">
                                  <path id="Path_20172" data-name="Path 20172" d="M154.227,58.969H130.584V34.324h23.643ZM130.6,58.954h23.613V34.338H130.6Z" transform="translate(-130.584 -34.324)" fill="#e0e0e0" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15058" data-name="Group 15058" transform="translate(3.184 3.318)">
                <g id="Group_15057" data-name="Group 15057">
                  <g id="Group_15056" data-name="Group 15056">
                    <g id="Group_15055" data-name="Group 15055">
                      <g id="Group_15054" data-name="Group 15054">
                        <g id="Group_15053" data-name="Group 15053">
                          <g id="Group_15052" data-name="Group 15052">
                            <g id="Group_15051" data-name="Group 15051">
                              <g id="Group_15050" data-name="Group 15050">
                                <g id="Group_15049" data-name="Group 15049">
                                  <rect id="Rectangle_18363" data-name="Rectangle 18363" width="17.276" height="18.008" fill="#fff" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15069" data-name="Group 15069" transform="translate(0.03 21.445)">
                <g id="Group_15068" data-name="Group 15068">
                  <g id="Group_15067" data-name="Group 15067">
                    <g id="Group_15066" data-name="Group 15066">
                      <g id="Group_15065" data-name="Group 15065">
                        <g id="Group_15064" data-name="Group 15064">
                          <g id="Group_15063" data-name="Group 15063">
                            <g id="Group_15062" data-name="Group 15062">
                              <g id="Group_15061" data-name="Group 15061">
                                <g id="Group_15060" data-name="Group 15060">
                                  <g id="Group_15059" data-name="Group 15059">
                                    <path id="Path_20173" data-name="Path 20173" d="M133.83,99.56a2.842,2.842,0,0,1-.426.5c-.276.291-.664.685-1.1,1.113s-.834.81-1.129,1.081a2.76,2.76,0,0,1-.5.416,2.76,2.76,0,0,1,.424-.494c.276-.291.665-.686,1.1-1.115s.836-.812,1.131-1.082A2.69,2.69,0,0,1,133.83,99.56Z" transform="translate(-130.676 -99.559)" fill="#e0e0e0" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15080" data-name="Group 15080" transform="translate(20.458 21.401)">
                <g id="Group_15079" data-name="Group 15079" transform="translate(0 0)">
                  <g id="Group_15078" data-name="Group 15078">
                    <g id="Group_15077" data-name="Group 15077">
                      <g id="Group_15076" data-name="Group 15076">
                        <g id="Group_15075" data-name="Group 15075">
                          <g id="Group_15074" data-name="Group 15074">
                            <g id="Group_15073" data-name="Group 15073">
                              <g id="Group_15072" data-name="Group 15072">
                                <g id="Group_15071" data-name="Group 15071">
                                  <g id="Group_15070" data-name="Group 15070">
                                    <path id="Path_20174" data-name="Path 20174" d="M192.818,99.426a2.811,2.811,0,0,1,.5.426c.291.276.685.664,1.113,1.1s.81.834,1.08,1.129a2.736,2.736,0,0,1,.416.5,2.78,2.78,0,0,1-.493-.424c-.291-.276-.686-.665-1.115-1.1s-.812-.836-1.082-1.131A2.7,2.7,0,0,1,192.818,99.426Z" transform="translate(-192.817 -99.426)" fill="#e0e0e0" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15091" data-name="Group 15091" transform="translate(20.411 0.26)">
                <g id="Group_15090" data-name="Group 15090">
                  <g id="Group_15089" data-name="Group 15089">
                    <g id="Group_15088" data-name="Group 15088">
                      <g id="Group_15087" data-name="Group 15087">
                        <g id="Group_15086" data-name="Group 15086">
                          <g id="Group_15085" data-name="Group 15085">
                            <g id="Group_15084" data-name="Group 15084">
                              <g id="Group_15083" data-name="Group 15083">
                                <g id="Group_15082" data-name="Group 15082">
                                  <g id="Group_15081" data-name="Group 15081">
                                    <path id="Path_20175" data-name="Path 20175" d="M192.674,38.222a2.841,2.841,0,0,1,.426-.5c.276-.291.663-.685,1.1-1.113s.834-.81,1.129-1.081a2.749,2.749,0,0,1,.5-.416,2.761,2.761,0,0,1-.424.493c-.276.291-.664.686-1.1,1.115s-.836.812-1.131,1.082A2.7,2.7,0,0,1,192.674,38.222Z" transform="translate(-192.674 -35.116)" fill="#e0e0e0" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15102" data-name="Group 15102" transform="translate(0.031 0.257)">
                <g id="Group_15101" data-name="Group 15101">
                  <g id="Group_15100" data-name="Group 15100">
                    <g id="Group_15099" data-name="Group 15099">
                      <g id="Group_15098" data-name="Group 15098">
                        <g id="Group_15097" data-name="Group 15097">
                          <g id="Group_15096" data-name="Group 15096">
                            <g id="Group_15095" data-name="Group 15095">
                              <g id="Group_15094" data-name="Group 15094">
                                <g id="Group_15093" data-name="Group 15093">
                                  <g id="Group_15092" data-name="Group 15092">
                                    <path id="Path_20176" data-name="Path 20176" d="M133.783,38.26a2.841,2.841,0,0,1-.5-.426c-.291-.276-.685-.664-1.113-1.1s-.81-.834-1.08-1.129a2.745,2.745,0,0,1-.416-.5,2.748,2.748,0,0,1,.493.424c.291.276.686.665,1.115,1.1s.812.836,1.082,1.131A2.691,2.691,0,0,1,133.783,38.26Z" transform="translate(-130.677 -35.107)" fill="#e0e0e0" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15113" data-name="Group 15113" transform="translate(3.107 3.242)">
                <g id="Group_15112" data-name="Group 15112">
                  <g id="Group_15111" data-name="Group 15111">
                    <g id="Group_15110" data-name="Group 15110">
                      <g id="Group_15109" data-name="Group 15109">
                        <g id="Group_15108" data-name="Group 15108">
                          <g id="Group_15107" data-name="Group 15107">
                            <g id="Group_15106" data-name="Group 15106">
                              <g id="Group_15105" data-name="Group 15105">
                                <g id="Group_15104" data-name="Group 15104">
                                  <g id="Group_15103" data-name="Group 15103">
                                    <path id="Path_20177" data-name="Path 20177" d="M157.341,62.27a.77.77,0,0,1,0-.087c0-.061,0-.144,0-.251q0-.339-.008-.972c0-.853-.01-2.094-.017-3.67-.008-3.154-.02-7.647-.034-13.027l.067.066-17.227.01h0l.076-.077c0,6.61-.008,12.793-.011,18.008l-.066-.066,12.474.034,3.5.017.927.008.239,0a.79.79,0,0,1,.083,0,.5.5,0,0,1-.076,0l-.232,0-.914.008-3.489.017-12.516.034h-.066V62.27c0-5.215-.007-11.4-.011-18.008v-.077h.078l17.227.01h.067v.067c-.014,5.4-.026,9.906-.034,13.07-.008,1.57-.013,2.806-.017,3.655q-.005.624-.008.959c0,.1,0,.184,0,.244A.563.563,0,0,1,157.341,62.27Z" transform="translate(-140.036 -44.185)" fill="#e0e0e0" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15123" data-name="Group 15123" transform="translate(8.939 9.44)">
                <g id="Group_15122" data-name="Group 15122">
                  <g id="Group_15121" data-name="Group 15121">
                    <g id="Group_15120" data-name="Group 15120">
                      <g id="Group_15119" data-name="Group 15119">
                        <g id="Group_15118" data-name="Group 15118">
                          <g id="Group_15117" data-name="Group 15117">
                            <g id="Group_15116" data-name="Group 15116">
                              <g id="Group_15115" data-name="Group 15115">
                                <g id="Group_15114" data-name="Group 15114">
                                  <rect id="Rectangle_18364" data-name="Rectangle 18364" width="5.765" height="5.765" fill="#ebebeb" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="Group_15170" data-name="Group 15170" transform="translate(0 17.7)">
              <g id="Group_15127" data-name="Group 15127" transform="translate(1.155 0)">
                <g id="Group_15126" data-name="Group 15126">
                  <g id="Group_15125" data-name="Group 15125">
                    <rect id="Rectangle_18365" data-name="Rectangle 18365" width="22.967" height="33.29" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15130" data-name="Group 15130" transform="translate(0.004 0)">
                <g id="Group_15129" data-name="Group 15129">
                  <g id="Group_15128" data-name="Group 15128">
                    <rect id="Rectangle_18366" data-name="Rectangle 18366" width="22.967" height="33.29" fill="#f5f5f5" />
                  </g>
                </g>
              </g>
              <g id="Group_15138" data-name="Group 15138" transform="translate(2.795 3.544)">
                <g id="Group_15133" data-name="Group 15133" transform="translate(0.062 0.062)">
                  <g id="Group_15132" data-name="Group 15132">
                    <g id="Group_15131" data-name="Group 15131">
                      <rect id="Rectangle_18367" data-name="Rectangle 18367" width="17.26" height="26.079" fill="#fff" />
                    </g>
                  </g>
                </g>
                <g id="Group_15137" data-name="Group 15137">
                  <g id="Group_15136" data-name="Group 15136">
                    <g id="Group_15135" data-name="Group 15135">
                      <g id="Group_15134" data-name="Group 15134">
                        <path id="Path_20178" data-name="Path 20178" d="M64.8,125.086s0-.044,0-.128,0-.209,0-.37c0-.328,0-.808-.007-1.431,0-1.25-.009-3.071-.015-5.372-.007-4.6-.017-11.11-.028-18.779l.058.057-17.258.005h0l.062-.062c0,9.838-.009,18.909-.013,26.079l-.05-.05,12.563.026,3.471.013.911.006c.206,0,.315.005.315.005s-.1,0-.3.006l-.9.006-3.46.012-12.594.026h-.05v-.05c0-7.17-.008-16.241-.012-26.079v-.062h.064L64.8,98.95h.057v.057c-.012,7.684-.021,14.209-.028,18.816-.007,2.3-.012,4.112-.015,5.359,0,.618-.005,1.094-.007,1.419,0,.158,0,.278,0,.363S64.8,125.086,64.8,125.086Z" transform="translate(-47.474 -98.945)" fill="#e0e0e0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15142" data-name="Group 15142" transform="translate(19.317 3.78)">
                <g id="Group_15141" data-name="Group 15141">
                  <g id="Group_15140" data-name="Group 15140">
                    <g id="Group_15139" data-name="Group 15139">
                      <path id="Path_20179" data-name="Path 20179" d="M97.733,99.664" transform="translate(-97.733 -99.664)" fill="none" stroke="#fbfbfb" strokeMiterlimit="10" strokeWidth="0.25" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15146" data-name="Group 15146" transform="translate(19.907 0)">
                <g id="Group_15145" data-name="Group 15145">
                  <g id="Group_15144" data-name="Group 15144">
                    <g id="Group_15143" data-name="Group 15143">
                      <path id="Path_20180" data-name="Path 20180" d="M102.656,88.166a3.978,3.978,0,0,1-.409.595c-.267.357-.646.842-1.078,1.367s-.836.99-1.135,1.32a3.98,3.98,0,0,1-.505.516,4.27,4.27,0,0,1,.439-.573l1.106-1.342,1.1-1.342A4.261,4.261,0,0,1,102.656,88.166Z" transform="translate(-99.528 -88.166)" fill="#e0e0e0" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15154" data-name="Group 15154" transform="translate(20.204 29.6)">
                <g id="Group_15149" data-name="Group 15149" transform="translate(0.001 0)">
                  <g id="Group_15148" data-name="Group 15148">
                    <g id="Group_15147" data-name="Group 15147">
                      <path id="Path_20181" data-name="Path 20181" d="M100.435,178.209a21.38,21.38,0,0,0,3.011,3.765" transform="translate(-100.435 -178.209)" fill="#fff" />
                    </g>
                  </g>
                </g>
                <g id="Group_15153" data-name="Group 15153" transform="translate(0)">
                  <g id="Group_15152" data-name="Group 15152">
                    <g id="Group_15151" data-name="Group 15151">
                      <g id="Group_15150" data-name="Group 15150">
                        <path id="Path_20182" data-name="Path 20182" d="M103.444,181.973a3.44,3.44,0,0,1-.525-.478,16.842,16.842,0,0,1-2.135-2.67,3.424,3.424,0,0,1-.35-.617,4.677,4.677,0,0,1,.423.567c.253.355.609.842,1.024,1.361s.811.973,1.1,1.3A4.762,4.762,0,0,1,103.444,181.973Z" transform="translate(-100.432 -178.208)" fill="#e0e0e0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15162" data-name="Group 15162" transform="translate(0 29.552)">
                <g id="Group_15157" data-name="Group 15157" transform="translate(0.001 0)">
                  <g id="Group_15156" data-name="Group 15156">
                    <g id="Group_15155" data-name="Group 15155">
                      <path id="Path_20183" data-name="Path 20183" d="M38.974,181.773l3.008-3.712" transform="translate(-38.974 -178.061)" fill="#fff" />
                    </g>
                  </g>
                </g>
                <g id="Group_15161" data-name="Group 15161">
                  <g id="Group_15160" data-name="Group 15160">
                    <g id="Group_15159" data-name="Group 15159">
                      <g id="Group_15158" data-name="Group 15158">
                        <path id="Path_20184" data-name="Path 20184" d="M41.981,178.06a22.892,22.892,0,0,1-1.456,1.9,22.953,22.953,0,0,1-1.553,1.817,22.774,22.774,0,0,1,1.456-1.9A22.79,22.79,0,0,1,41.981,178.06Z" transform="translate(-38.972 -178.06)" fill="#e0e0e0" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15166" data-name="Group 15166" transform="translate(0.003)">
                <g id="Group_15165" data-name="Group 15165">
                  <g id="Group_15164" data-name="Group 15164">
                    <g id="Group_15163" data-name="Group 15163">
                      <path id="Path_20185" data-name="Path 20185" d="M38.982,88.166a20.812,20.812,0,0,1,1.46,1.746A20.643,20.643,0,0,1,41.8,91.735a20.866,20.866,0,0,1-1.46-1.746A20.761,20.761,0,0,1,38.982,88.166Z" transform="translate(-38.981 -88.166)" fill="#e0e0e0" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15169" data-name="Group 15169" transform="translate(8.961 8.901)">
                <g id="Group_15168" data-name="Group 15168">
                  <g id="Group_15167" data-name="Group 15167">
                    <rect id="Rectangle_18368" data-name="Rectangle 18368" width="5.779" height="16.409" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Floor" transform="translate(22.137 173.711)">
            <g id="Group_15173" data-name="Group 15173" transform="translate(0 0)">
              <g id="Group_15172" data-name="Group 15172">
                <g id="Group_15171" data-name="Group 15171">
                  <path id="Path_20186" data-name="Path 20186" d="M254.136,458.416c0,.047-51.939.085-115.994.085-64.077,0-116.005-.039-116.005-.085s51.928-.086,116.005-.086C202.2,458.33,254.136,458.368,254.136,458.416Z" transform="translate(-22.137 -458.33)" fill="#263238" />
                </g>
              </g>
            </g>
          </g>
          <g id="Device" transform="translate(70.406 71.281)">
            <g id="Group_15205" data-name="Group 15205">
              <g id="Group_15198" data-name="Group 15198">
                <g id="Group_15179" data-name="Group 15179" transform="translate(6.396)">
                  <g id="Group_15178" data-name="Group 15178">
                    <g id="Group_15177" data-name="Group 15177">
                      <g id="Group_15176" data-name="Group 15176">
                        <g id="Group_15175" data-name="Group 15175">
                          <g id="Group_15174" data-name="Group 15174">
                            <path id="Rectangle_18369" data-name="Rectangle 18369" d="M7.751,0H146.208a6.74,6.74,0,0,1,6.74,6.74V86.576a14.567,14.567,0,0,1-14.567,14.567H14.567A14.567,14.567,0,0,1,0,86.576V7.751A7.751,7.751,0,0,1,7.751,0Z" fill="#263238" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15185" data-name="Group 15185" transform="translate(0 93.663)">
                  <g id="Group_15184" data-name="Group 15184">
                    <g id="Group_15183" data-name="Group 15183">
                      <g id="Group_15182" data-name="Group 15182">
                        <g id="Group_15181" data-name="Group 15181">
                          <g id="Group_15180" data-name="Group 15180">
                            <path id="Rectangle_18370" data-name="Rectangle 18370" d="M0,0H165.708a0,0,0,0,1,0,0V0a8.85,8.85,0,0,1-8.85,8.85H8.85A8.85,8.85,0,0,1,0,0V0A0,0,0,0,1,0,0Z" fill="#263238" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15191" data-name="Group 15191" transform="translate(10.502 4.019)">
                  <g id="Group_15190" data-name="Group 15190">
                    <g id="Group_15189" data-name="Group 15189">
                      <g id="Group_15188" data-name="Group 15188">
                        <g id="Group_15187" data-name="Group 15187">
                          <g id="Group_15186" data-name="Group 15186">
                            <rect id="Rectangle_18371" data-name="Rectangle 18371" width="144.309" height="85.413" fill="#f5f5f5" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15197" data-name="Group 15197" transform="translate(67.793 93.663)">
                  <g id="Group_15196" data-name="Group 15196">
                    <g id="Group_15195" data-name="Group 15195">
                      <g id="Group_15194" data-name="Group 15194">
                        <g id="Group_15193" data-name="Group 15193">
                          <g id="Group_15192" data-name="Group 15192">
                            <path id="Path_20187" data-name="Path 20187" d="M375.187,431.659l2.056,3.271h28.934l1.91-3.271Z" transform="translate(-375.187 -431.659)" fill="#455a64" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15204" data-name="Group 15204" transform="translate(6.421 93.632)">
                <g id="Group_15203" data-name="Group 15203">
                  <g id="Group_15202" data-name="Group 15202">
                    <g id="Group_15201" data-name="Group 15201">
                      <g id="Group_15200" data-name="Group 15200">
                        <g id="Group_15199" data-name="Group 15199">
                          <rect id="Rectangle_18372" data-name="Rectangle 18372" width="152.948" height="0.488" fill="#455a64" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Article" transform="translate(86.421 41.918)">
            <g id="Group_15395" data-name="Group 15395">
              <g id="Group_15211" data-name="Group 15211" transform="translate(115.342 21.384)">
                <g id="Group_15207" data-name="Group 15207" transform="translate(0.085 0.034)">
                  <g id="Group_15206" data-name="Group 15206">
                    <path id="Path_20188" data-name="Path 20188" d="M576.861,122.576h6.818v74.106c0,4.9-3.218,8.868-7.189,8.868h-7.685V122.576Z" transform="translate(-568.806 -122.576)" fill="#e0e0e0" />
                  </g>
                </g>
                <g id="Group_15210" data-name="Group 15210">
                  <g id="Group_15209" data-name="Group 15209">
                    <g id="Group_15208" data-name="Group 15208">
                      <path id="Path_20189" data-name="Path 20189" d="M576.687,122.506s-.176.006-.522.009l-1.541.009-5.992.016.034-.034c.009,13.994.028,45.64.051,82.974l-.085-.085h7.01c.315,0,.636.012.944-.017l.466-.03.458-.086a6.478,6.478,0,0,0,3.207-1.762,8.616,8.616,0,0,0,1.989-3.067,10.44,10.44,0,0,0,.7-3.559c0-4.873.009-9.624.014-14.224,0-9.2.008-17.8.011-25.555.017-15.511.031-27.665.039-34.589l.031.031-5.086-.015-1.3-.008c-.29,0-.437-.008-.437-.008s.147-.005.437-.008l1.3-.008,5.086-.015h.031v.031c.008,6.923.021,19.077.039,34.589,0,7.757.007,16.354.011,25.555,0,4.6-.005,9.354-.008,14.228a10.612,10.612,0,0,1-.715,3.617,8.793,8.793,0,0,1-2.028,3.127,6.65,6.65,0,0,1-3.291,1.808l-.471.089-.479.031c-.322.029-.634.012-.952.017h-7.1v-.085c.023-37.335.043-68.981.052-82.974v-.034h.034l5.992.016,1.541.009C576.511,122.5,576.687,122.506,576.687,122.506Z" transform="translate(-568.546 -122.472)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15217" data-name="Group 15217">
                <g id="Group_15213" data-name="Group 15213" transform="translate(0.085 0.086)">
                  <g id="Group_15212" data-name="Group 15212">
                    <path id="Path_20190" data-name="Path 20190" d="M341.342,161.991H224.394a6.449,6.449,0,0,1-6.449-6.449V57.684h123.4Z" transform="translate(-217.945 -57.684)" fill="#fff" />
                  </g>
                </g>
                <g id="Group_15216" data-name="Group 15216">
                  <g id="Group_15215" data-name="Group 15215">
                    <g id="Group_15214" data-name="Group 15214">
                      <path id="Path_20191" data-name="Path 20191" d="M341.167,161.816c0-.605-.029-41.483-.072-104.307l.072.072-122,.013h-1.4l.085-.085c0,31.1,0,60.706-.007,87.625q0,5.047,0,9.966a6.865,6.865,0,0,0,.367,2.382,6.379,6.379,0,0,0,5.32,4.221c.781.065,1.584.028,2.372.039h7.035l9.122,0,33.267.013,65.839.057-65.8.057-33.291.014-9.13,0h-7.041c-.793-.011-1.582.028-2.389-.038a6.532,6.532,0,0,1-5.449-4.319,7.025,7.025,0,0,1-.376-2.433q0-4.918,0-9.966c0-26.919,0-56.526-.007-87.625v-.086h1.482l122,.014h.072v.072C341.2,120.333,341.168,161.211,341.167,161.816Z" transform="translate(-217.685 -57.423)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15220" data-name="Group 15220" transform="translate(0.085 9.436)">
                <g id="Group_15219" data-name="Group 15219">
                  <g id="Group_15218" data-name="Group 15218">
                    <path id="Path_20192" data-name="Path 20192" d="M341.342,86.213c0,.047-27.626.085-61.7.085s-61.7-.038-61.7-.085,27.62-.086,61.7-.086S341.342,86.165,341.342,86.213Z" transform="translate(-217.945 -86.127)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15226" data-name="Group 15226" transform="translate(40.825 4.778)">
                <g id="Group_15222" data-name="Group 15222" transform="translate(0 0.086)">
                  <g id="Group_15221" data-name="Group 15221">
                    <path id="Path_20193" data-name="Path 20193" d="M341.871,72.217h43.76" transform="translate(-341.871 -72.217)" fill="#e0e0e0" />
                  </g>
                </g>
                <g id="Group_15225" data-name="Group 15225">
                  <g id="Group_15224" data-name="Group 15224">
                    <g id="Group_15223" data-name="Group 15223">
                      <path id="Path_20194" data-name="Path 20194" d="M385.631,72.042c0,.047-9.8.085-21.879.085s-21.881-.038-21.881-.085,9.795-.086,21.881-.086S385.631,71.994,385.631,72.042Z" transform="translate(-341.871 -71.956)" fill="#ff725e" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15228" data-name="Group 15228" transform="translate(3.052 3.552)">
                <g id="Group_15227" data-name="Group 15227">
                  <circle id="Ellipse_1506" data-name="Ellipse 1506" cx="1.177" cy="1.177" r="1.177" fill="#e0e0e0" />
                </g>
              </g>
              <g id="Group_15230" data-name="Group 15230" transform="translate(7.042 3.552)">
                <g id="Group_15229" data-name="Group 15229">
                  <circle id="Ellipse_1507" data-name="Ellipse 1507" cx="1.177" cy="1.177" r="1.177" fill="#e0e0e0" />
                </g>
              </g>
              <g id="Group_15232" data-name="Group 15232" transform="translate(11.032 3.552)">
                <g id="Group_15231" data-name="Group 15231">
                  <circle id="Ellipse_1508" data-name="Ellipse 1508" cx="1.177" cy="1.177" r="1.177" fill="#e0e0e0" />
                </g>
              </g>
              <g id="Group_15240" data-name="Group 15240" transform="translate(44.558 18.957)">
                <g id="Group_15233" data-name="Group 15233" transform="translate(0 0.09)">
                  <path id="Path_20195" data-name="Path 20195" d="M357.377,119.491h-2.439l-.465,1.126h-1.246l2.341-5.253h1.2l2.348,5.253h-1.276Zm-.383-.923-.833-2.011-.833,2.011Z" transform="translate(-353.227 -115.364)" fill="#455a64" />
                </g>
                <g id="Group_15234" data-name="Group 15234" transform="translate(6.437 0.09)">
                  <path id="Path_20196" data-name="Path 20196" d="M376.156,120.617l-1.013-1.463h-1.118v1.463h-1.216v-5.253h2.274c1.4,0,2.281.728,2.281,1.906a1.708,1.708,0,0,1-1.081,1.658l1.178,1.688Zm-1.141-4.262h-.99v1.831h.99c.743,0,1.118-.345,1.118-.916S375.758,116.354,375.015,116.354Z" transform="translate(-372.809 -115.364)" fill="#455a64" />
                </g>
                <g id="Group_15235" data-name="Group 15235" transform="translate(11.284 0.09)">
                  <path id="Path_20197" data-name="Path 20197" d="M389.233,116.354h-1.681v-.99h4.578v.99h-1.681v4.262h-1.216Z" transform="translate(-387.552 -115.364)" fill="#455a64" />
                </g>
                <g id="Group_15236" data-name="Group 15236" transform="translate(16.514 0.09)">
                  <path id="Path_20198" data-name="Path 20198" d="M403.462,115.364h1.216v5.253h-1.216Z" transform="translate(-403.462 -115.364)" fill="#455a64" />
                </g>
                <g id="Group_15237" data-name="Group 15237" transform="translate(18.645)">
                  <path id="Path_20199" data-name="Path 20199" d="M409.943,117.806a2.892,2.892,0,0,1,5.013-1.786l-.78.72a1.691,1.691,0,0,0-1.321-.615,1.681,1.681,0,0,0,0,3.362,1.674,1.674,0,0,0,1.321-.623l.78.721a2.887,2.887,0,0,1-5.013-1.779Z" transform="translate(-409.943 -115.09)" fill="#455a64" />
                </g>
                <g id="Group_15238" data-name="Group 15238" transform="translate(24.474 0.09)">
                  <path id="Path_20200" data-name="Path 20200" d="M427.676,115.364h1.216v4.262h2.634v.99h-3.85Z" transform="translate(-427.676 -115.364)" fill="#455a64" />
                </g>
                <g id="Group_15239" data-name="Group 15239" transform="translate(29.006 0.09)">
                  <path id="Path_20201" data-name="Path 20201" d="M445.529,119.642v.975h-4.067v-5.253h3.969v.976H442.67v1.141h2.439v.945H442.67v1.216Z" transform="translate(-441.462 -115.364)" fill="#455a64" />
                </g>
              </g>
              <g id="Group_15243" data-name="Group 15243" transform="translate(47.788 35.803)">
                <g id="Group_15242" data-name="Group 15242">
                  <g id="Group_15241" data-name="Group 15241">
                    <path id="Path_20202" data-name="Path 20202" d="M373.978,166.419c0,.047-2.446.085-5.462.085s-5.463-.038-5.463-.085,2.445-.086,5.463-.086S373.978,166.371,373.978,166.419Z" transform="translate(-363.053 -166.333)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15246" data-name="Group 15246" transform="translate(61.835 35.803)">
                <g id="Group_15245" data-name="Group 15245">
                  <g id="Group_15244" data-name="Group 15244">
                    <path id="Path_20203" data-name="Path 20203" d="M417.747,166.419c0,.047-2.678.085-5.982.085s-5.983-.038-5.983-.085,2.678-.086,5.983-.086S417.747,166.371,417.747,166.419Z" transform="translate(-405.782 -166.333)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15249" data-name="Group 15249" transform="translate(47.892 41.317)">
                <g id="Group_15248" data-name="Group 15248">
                  <g id="Group_15247" data-name="Group 15247">
                    <path id="Path_20204" data-name="Path 20204" d="M388.758,183.194c0,.047-5.684.085-12.693.085s-12.695-.038-12.695-.085,5.683-.086,12.695-.086S388.758,183.146,388.758,183.194Z" transform="translate(-363.37 -183.108)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15252" data-name="Group 15252" transform="translate(48.1 46.208)">
                <g id="Group_15251" data-name="Group 15251">
                  <g id="Group_15250" data-name="Group 15250">
                    <path id="Path_20205" data-name="Path 20205" d="M389.7,198.069c0,.047-5.754.086-12.849.086S364,198.117,364,198.069s5.752-.085,12.851-.085S389.7,198.022,389.7,198.069Z" transform="translate(-364.003 -197.984)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15255" data-name="Group 15255" transform="translate(48.205 51.514)">
                <g id="Group_15254" data-name="Group 15254">
                  <g id="Group_15253" data-name="Group 15253">
                    <path id="Path_20206" data-name="Path 20206" d="M374.725,214.211c0,.047-2.329.086-5.2.086s-5.2-.038-5.2-.086,2.329-.085,5.2-.085S374.725,214.164,374.725,214.211Z" transform="translate(-364.32 -214.126)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15258" data-name="Group 15258" transform="translate(60.794 51.41)">
                <g id="Group_15257" data-name="Group 15257">
                  <g id="Group_15256" data-name="Group 15256">
                    <path id="Path_20207" data-name="Path 20207" d="M414.062,213.895c0,.047-2.563.085-5.722.085s-5.723-.038-5.723-.085,2.562-.086,5.723-.086S414.062,213.847,414.062,213.895Z" transform="translate(-402.617 -213.809)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15261" data-name="Group 15261" transform="translate(48.1 56.821)">
                <g id="Group_15260" data-name="Group 15260">
                  <g id="Group_15259" data-name="Group 15259">
                    <path id="Path_20208" data-name="Path 20208" d="M388.142,230.353c0,.047-5.4.086-12.069.086S364,230.4,364,230.353s5.4-.085,12.07-.085S388.142,230.306,388.142,230.353Z" transform="translate(-364.003 -230.268)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15264" data-name="Group 15264" transform="translate(16.366 66.913)">
                <g id="Group_15263" data-name="Group 15263">
                  <g id="Group_15262" data-name="Group 15262">
                    <path id="Path_20209" data-name="Path 20209" d="M277.561,261.054c0,.047-2.259.086-5.046.086s-5.047-.038-5.047-.086,2.259-.085,5.047-.085S277.561,261.007,277.561,261.054Z" transform="translate(-267.468 -260.969)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15267" data-name="Group 15267" transform="translate(29.996 67.225)">
                <g id="Group_15266" data-name="Group 15266">
                  <g id="Group_15265" data-name="Group 15265">
                    <path id="Path_20210" data-name="Path 20210" d="M320.584,262c0,.047-2.609.085-5.827.085s-5.827-.038-5.827-.085,2.608-.086,5.827-.086S320.584,261.956,320.584,262Z" transform="translate(-308.931 -261.918)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15270" data-name="Group 15270" transform="translate(16.678 72.22)">
                <g id="Group_15269" data-name="Group 15269">
                  <g id="Group_15268" data-name="Group 15268">
                    <path id="Path_20211" data-name="Path 20211" d="M293.7,277.2c0,.047-5.66.086-12.641.086s-12.642-.038-12.642-.086,5.659-.086,12.642-.086S293.7,277.15,293.7,277.2Z" transform="translate(-268.418 -277.111)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15273" data-name="Group 15273" transform="translate(16.262 77.318)">
                <g id="Group_15272" data-name="Group 15272">
                  <g id="Group_15271" data-name="Group 15271">
                    <path id="Path_20212" data-name="Path 20212" d="M294.413,292.705c0,.047-6.1.085-13.63.085s-13.631-.038-13.631-.085,6.1-.085,13.631-.085S294.413,292.658,294.413,292.705Z" transform="translate(-267.152 -292.62)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15276" data-name="Group 15276" transform="translate(47.996 61.503)">
                <g id="Group_15275" data-name="Group 15275">
                  <g id="Group_15274" data-name="Group 15274">
                    <path id="Path_20213" data-name="Path 20213" d="M380.958,244.6c0,.047-3.867.085-8.636.085s-8.637-.038-8.637-.085,3.866-.085,8.637-.085S380.958,244.549,380.958,244.6Z" transform="translate(-363.686 -244.511)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15279" data-name="Group 15279" transform="translate(68.182 61.503)">
                <g id="Group_15278" data-name="Group 15278">
                  <g id="Group_15277" data-name="Group 15277">
                    <path id="Path_20214" data-name="Path 20214" d="M430.707,244.6a46.239,46.239,0,0,1-5.619,0,46.206,46.206,0,0,1,5.619,0Z" transform="translate(-425.089 -244.511)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15282" data-name="Group 15282" transform="translate(48.829 67.121)">
                <g id="Group_15281" data-name="Group 15281">
                  <g id="Group_15280" data-name="Group 15280">
                    <path id="Path_20215" data-name="Path 20215" d="M389.942,261.688c0,.047-5.311.086-11.861.086s-11.862-.038-11.862-.086,5.31-.086,11.862-.086S389.942,261.64,389.942,261.688Z" transform="translate(-366.219 -261.602)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15285" data-name="Group 15285" transform="translate(47.996 72.324)">
                <g id="Group_15284" data-name="Group 15284">
                  <g id="Group_15283" data-name="Group 15283">
                    <path id="Path_20216" data-name="Path 20216" d="M375.339,277.513c0,.047-2.609.085-5.826.085s-5.827-.038-5.827-.085,2.609-.086,5.827-.086S375.339,277.465,375.339,277.513Z" transform="translate(-363.686 -277.427)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15288" data-name="Group 15288" transform="translate(48.517 77.63)">
                <g id="Group_15287" data-name="Group 15287">
                  <g id="Group_15286" data-name="Group 15286">
                    <path id="Path_20217" data-name="Path 20217" d="M390.761,293.655c0,.047-5.707.085-12.745.085s-12.746-.038-12.746-.085,5.706-.086,12.746-.086S390.761,293.607,390.761,293.655Z" transform="translate(-365.269 -293.569)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15291" data-name="Group 15291" transform="translate(62.563 72.428)">
                <g id="Group_15290" data-name="Group 15290">
                  <g id="Group_15289" data-name="Group 15289">
                    <path id="Path_20218" data-name="Path 20218" d="M420.483,277.829c0,.047-2.8.086-6.242.086s-6.243-.038-6.243-.086,2.795-.085,6.243-.085S420.483,277.783,420.483,277.829Z" transform="translate(-407.997 -277.744)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15294" data-name="Group 15294" transform="translate(79.107 35.907)">
                <g id="Group_15293" data-name="Group 15293">
                  <g id="Group_15292" data-name="Group 15292">
                    <path id="Path_20219" data-name="Path 20219" d="M484.854,166.735c0,.047-5.94.086-13.266.086s-13.267-.038-13.267-.086,5.939-.085,13.267-.085S484.854,166.688,484.854,166.735Z" transform="translate(-458.322 -166.65)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15297" data-name="Group 15297" transform="translate(79.315 40.901)">
                <g id="Group_15296" data-name="Group 15296">
                  <g id="Group_15295" data-name="Group 15295">
                    <path id="Path_20220" data-name="Path 20220" d="M464.261,181.927a41.074,41.074,0,0,1-5.306,0,41.228,41.228,0,0,1,5.306,0Z" transform="translate(-458.955 -181.842)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15300" data-name="Group 15300" transform="translate(87.014 41.006)">
                <g id="Group_15299" data-name="Group 15299">
                  <g id="Group_15298" data-name="Group 15298">
                    <path id="Path_20221" data-name="Path 20221" d="M501,182.244c0,.047-4.17.086-9.312.086s-9.312-.038-9.312-.086,4.169-.085,9.312-.085S501,182.2,501,182.244Z" transform="translate(-482.377 -182.159)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15303" data-name="Group 15303" transform="translate(80.043 46)">
                <g id="Group_15302" data-name="Group 15302">
                  <g id="Group_15301" data-name="Group 15301">
                    <path id="Path_20222" data-name="Path 20222" d="M485.414,197.436c0,.047-5.427.086-12.121.086s-12.122-.038-12.122-.086,5.426-.085,12.122-.085S485.414,197.389,485.414,197.436Z" transform="translate(-461.171 -197.351)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15306" data-name="Group 15306" transform="translate(80.147 50.994)">
                <g id="Group_15305" data-name="Group 15305">
                  <g id="Group_15304" data-name="Group 15304">
                    <path id="Path_20223" data-name="Path 20223" d="M486.459,212.629c0,.047-5.591.085-12.485.085s-12.487-.038-12.487-.085,5.59-.086,12.487-.086S486.459,212.581,486.459,212.629Z" transform="translate(-461.487 -212.543)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15309" data-name="Group 15309" transform="translate(80.043 56.3)">
                <g id="Group_15308" data-name="Group 15308">
                  <g id="Group_15307" data-name="Group 15307">
                    <path id="Path_20224" data-name="Path 20224" d="M472.824,228.771c0,.047-2.609.085-5.827.085s-5.827-.038-5.827-.085,2.608-.086,5.827-.086S472.824,228.723,472.824,228.771Z" transform="translate(-461.171 -228.685)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15312" data-name="Group 15312" transform="translate(94.714 56.405)">
                <g id="Group_15311" data-name="Group 15311">
                  <g id="Group_15310" data-name="Group 15310">
                    <path id="Path_20225" data-name="Path 20225" d="M516.2,229.088c0,.047-2.329.086-5.2.086s-5.2-.038-5.2-.086S508.127,229,511,229,516.2,229.04,516.2,229.088Z" transform="translate(-505.798 -229.002)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15315" data-name="Group 15315" transform="translate(16.797 22.058)">
                <g id="Group_15314" data-name="Group 15314">
                  <g id="Group_15313" data-name="Group 15313">
                    <path id="Path_20226" data-name="Path 20226" d="M293.944,124.608c0,.047-5.634.085-12.582.085s-12.583-.038-12.583-.085,5.633-.085,12.583-.085S293.944,124.561,293.944,124.608Z" transform="translate(-268.779 -124.523)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15318" data-name="Group 15318" transform="translate(82.451 22.058)">
                <g id="Group_15317" data-name="Group 15317">
                  <g id="Group_15316" data-name="Group 15316">
                    <path id="Path_20227" data-name="Path 20227" d="M494.917,124.608c0,.047-5.915.085-13.21.085s-13.211-.038-13.211-.085,5.914-.085,13.211-.085S494.917,124.561,494.917,124.608Z" transform="translate(-468.495 -124.523)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15349" data-name="Group 15349" transform="translate(79.022 61.532)">
                <g id="Group_15323" data-name="Group 15323">
                  <g id="Group_15322" data-name="Group 15322">
                    <g id="Group_15321" data-name="Group 15321">
                      <g id="Group_15320" data-name="Group 15320">
                        <g id="Group_15319" data-name="Group 15319">
                          <path id="Path_20228" data-name="Path 20228" d="M487.216,245.546c-.012.025-.408-.2-1.184-.45a7.614,7.614,0,0,0-3.4-.252,7.421,7.421,0,0,0-2.24.72,10.563,10.563,0,0,0-2.2,1.585c-.722.637-1.44,1.361-2.267,2.031a7.819,7.819,0,0,1-2.893,1.566,4.369,4.369,0,0,1-1.689.1,5.464,5.464,0,0,1-1.565-.483,27.349,27.349,0,0,1-2.622-1.559,8.172,8.172,0,0,0-2.466-1.106,7.329,7.329,0,0,0-2.346-.18,7.56,7.56,0,0,0-3.238,1.054c-.695.425-1.023.744-1.041.722a1.582,1.582,0,0,1,.235-.231,5.613,5.613,0,0,1,.753-.573,7.387,7.387,0,0,1,5.685-.994,8.307,8.307,0,0,1,2.538,1.11,28.036,28.036,0,0,0,2.6,1.533,4.462,4.462,0,0,0,3.089.362,7.642,7.642,0,0,0,2.8-1.514c.814-.654,1.535-1.373,2.267-2.012a10.6,10.6,0,0,1,2.262-1.6,7.5,7.5,0,0,1,5.763-.375,5.983,5.983,0,0,1,.87.374A1.617,1.617,0,0,1,487.216,245.546Z" transform="translate(-458.063 -244.598)" fill="#ff725e" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15348" data-name="Group 15348" transform="translate(1.568 1.621)">
                  <g id="Group_15327" data-name="Group 15327" transform="translate(4.053 4.974)">
                    <g id="Group_15326" data-name="Group 15326">
                      <g id="Group_15325" data-name="Group 15325">
                        <g id="Group_15324" data-name="Group 15324">
                          <rect id="Rectangle_18373" data-name="Rectangle 18373" width="3.132" height="8.47" fill="#f46a4e" />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15331" data-name="Group 15331" transform="translate(17.342 4.974)">
                    <g id="Group_15330" data-name="Group 15330">
                      <g id="Group_15329" data-name="Group 15329">
                        <g id="Group_15328" data-name="Group 15328">
                          <rect id="Rectangle_18374" data-name="Rectangle 18374" width="3.132" height="8.47" fill="#f46a4e" />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15335" data-name="Group 15335" transform="translate(21.772)">
                    <g id="Group_15334" data-name="Group 15334">
                      <g id="Group_15333" data-name="Group 15333">
                        <g id="Group_15332" data-name="Group 15332">
                          <rect id="Rectangle_18375" data-name="Rectangle 18375" width="3.132" height="13.444" fill="#f46a4e" />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15339" data-name="Group 15339" transform="translate(0 10.778)">
                    <g id="Group_15338" data-name="Group 15338">
                      <g id="Group_15337" data-name="Group 15337">
                        <g id="Group_15336" data-name="Group 15336">
                          <rect id="Rectangle_18376" data-name="Rectangle 18376" width="3.132" height="2.851" fill="#f46a4e" />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15343" data-name="Group 15343" transform="translate(8.483 8.799)">
                    <g id="Group_15342" data-name="Group 15342">
                      <g id="Group_15341" data-name="Group 15341">
                        <g id="Group_15340" data-name="Group 15340">
                          <rect id="Rectangle_18377" data-name="Rectangle 18377" width="3.132" height="4.645" fill="#f46a4e" />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15347" data-name="Group 15347" transform="translate(12.913 7.733)">
                    <g id="Group_15346" data-name="Group 15346">
                      <g id="Group_15345" data-name="Group 15345">
                        <g id="Group_15344" data-name="Group 15344">
                          <rect id="Rectangle_18378" data-name="Rectangle 18378" width="3.132" height="5.712" fill="#f46a4e" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15376" data-name="Group 15376" transform="translate(16.78 35.889)">
                <g id="Group_15375" data-name="Group 15375">
                  <g id="Group_15355" data-name="Group 15355">
                    <g id="Group_15354" data-name="Group 15354">
                      <g id="Group_15353" data-name="Group 15353">
                        <g id="Group_15352" data-name="Group 15352">
                          <g id="Group_15351" data-name="Group 15351">
                            <g id="Group_15350" data-name="Group 15350">
                              <rect id="Rectangle_18379" data-name="Rectangle 18379" width="26.432" height="25.573" fill="#5da8a1" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15361" data-name="Group 15361" transform="translate(2.049 10.224)" opacity="0.3">
                    <g id="Group_15360" data-name="Group 15360">
                      <g id="Group_15359" data-name="Group 15359">
                        <g id="Group_15358" data-name="Group 15358">
                          <g id="Group_15357" data-name="Group 15357">
                            <g id="Group_15356" data-name="Group 15356">
                              <path id="Path_20229" data-name="Path 20229" d="M274.963,210.855l7.312-13.159,5.981,8.411,3.634-4.467,5.407,9.215Z" transform="translate(-274.963 -197.696)" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15367" data-name="Group 15367" transform="translate(14.085 5.763)" opacity="0.3">
                    <g id="Group_15366" data-name="Group 15366">
                      <g id="Group_15365" data-name="Group 15365">
                        <g id="Group_15364" data-name="Group 15364">
                          <g id="Group_15363" data-name="Group 15363">
                            <g id="Group_15362" data-name="Group 15362">
                              <path id="Path_20230" data-name="Path 20230" d="M314.871,184.633a1.972,1.972,0,0,1-2.787,2.787A1.972,1.972,0,0,1,314.871,184.633Z" transform="translate(-311.575 -184.124)" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15374" data-name="Group 15374" transform="translate(1.896 1.99)">
                    <g id="Group_15373" data-name="Group 15373">
                      <g id="Group_15372" data-name="Group 15372">
                        <g id="Group_15371" data-name="Group 15371" opacity="0.3">
                          <g id="Group_15370" data-name="Group 15370">
                            <g id="Group_15369" data-name="Group 15369">
                              <g id="Group_15368" data-name="Group 15368">
                                <path id="Path_20231" data-name="Path 20231" d="M296.982,194.111a.814.814,0,0,1-.006-.1c0-.077,0-.174-.006-.3q0-.408-.012-1.151c-.007-1.014-.016-2.481-.028-4.343-.013-3.735-.033-9.054-.056-15.441l.108.108-22.331.018c-.03.026.236-.237.124-.123v2.894q0,1.437,0,2.848c0,1.879,0,3.719,0,5.51,0,3.581-.009,6.968-.012,10.082l-.109-.109,16.147.056,4.554.029,1.208.013.313.006a.878.878,0,0,1,.11.006.523.523,0,0,1-.1.006l-.3.006-1.187.013-4.53.029-16.218.056h-.11v-.11c0-3.114-.008-6.5-.012-10.082,0-1.791,0-3.631,0-5.51q0-1.41,0-2.848,0-.718,0-1.443v-1.45c-.112.111.153-.157.128-.13l22.331.018h.108v.108c-.023,6.415-.042,11.757-.055,15.509-.012,1.852-.022,3.31-.028,4.319q-.008.729-.013,1.13c0,.119,0,.213-.006.287A.462.462,0,0,1,296.982,194.111Z" transform="translate(-274.495 -172.646)" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15379" data-name="Group 15379" transform="translate(16.427 82.689)">
                <g id="Group_15378" data-name="Group 15378">
                  <g id="Group_15377" data-name="Group 15377">
                    <path id="Path_20232" data-name="Path 20232" d="M294.793,309.042c0,.047-6.075.086-13.568.086s-13.569-.038-13.569-.086,6.074-.085,13.569-.085S294.793,309,294.793,309.042Z" transform="translate(-267.656 -308.957)" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15382" data-name="Group 15382" transform="translate(49.139 82.513)">
                <g id="Group_15381" data-name="Group 15381">
                  <g id="Group_15380" data-name="Group 15380">
                    <path id="Path_20233" data-name="Path 20233" d="M393.278,308.508c0,.047-5.846.086-13.057.086s-13.058-.038-13.058-.086,5.845-.086,13.058-.086S393.278,308.461,393.278,308.508Z" transform="translate(-367.163 -308.422)" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15385" data-name="Group 15385" transform="translate(81.618 82.017)">
                <g id="Group_15384" data-name="Group 15384">
                  <g id="Group_15383" data-name="Group 15383">
                    <path id="Path_20234" data-name="Path 20234" d="M491.911,307c0,.047-5.809.086-12.974.086s-12.975-.038-12.975-.086,5.808-.086,12.975-.086S491.911,306.952,491.911,307Z" transform="translate(-465.961 -306.914)" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15388" data-name="Group 15388" transform="translate(16.427 87.089)">
                <g id="Group_15387" data-name="Group 15387">
                  <g id="Group_15386" data-name="Group 15386">
                    <path id="Path_20235" data-name="Path 20235" d="M294.793,322.428c0,.047-6.075.085-13.568.085s-13.569-.038-13.569-.085,6.074-.086,13.569-.086S294.793,322.381,294.793,322.428Z" transform="translate(-267.656 -322.342)" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15391" data-name="Group 15391" transform="translate(49.139 86.913)">
                <g id="Group_15390" data-name="Group 15390">
                  <g id="Group_15389" data-name="Group 15389">
                    <path id="Path_20236" data-name="Path 20236" d="M393.278,321.893c0,.047-5.846.085-13.057.085s-13.058-.038-13.058-.085,5.845-.086,13.058-.086S393.278,321.845,393.278,321.893Z" transform="translate(-367.163 -321.807)" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
              <g id="Group_15394" data-name="Group 15394" transform="translate(81.618 86.417)">
                <g id="Group_15393" data-name="Group 15393">
                  <g id="Group_15392" data-name="Group 15392">
                    <path id="Path_20237" data-name="Path 20237" d="M491.911,320.384c0,.047-5.809.086-12.974.086s-12.975-.038-12.975-.086,5.808-.085,12.975-.085S491.911,320.337,491.911,320.384Z" transform="translate(-465.961 -320.299)" fill="#e0e0e0" />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Button" transform="translate(120.053 135.208)">
            <g id="Group_15406" data-name="Group 15406">
              <g id="Group_15397" data-name="Group 15397">
                <g id="Group_15396" data-name="Group 15396">
                  <rect id="Rectangle_18380" data-name="Rectangle 18380" width="60.366" height="17.73" rx="8.865" fill="#ff2000" />
                </g>
              </g>
              <g id="Group_15405" data-name="Group 15405" transform="translate(18.723 7.492)">
                <g id="Group_15398" data-name="Group 15398" transform="translate(0 0.061)">
                  <path id="Path_20238" data-name="Path 20238" d="M380.023,365.469c0,.791-.593,1.283-1.541,1.283h-.715v.979h-.822v-3.55h1.537C379.43,364.181,380.023,364.673,380.023,365.469Zm-.832,0c0-.391-.254-.619-.756-.619h-.669v1.232h.669C378.938,366.083,379.192,365.855,379.192,365.469Z" transform="translate(-376.945 -364.181)" fill="#fff" />
                </g>
                <g id="Group_15399" data-name="Group 15399" transform="translate(3.617 0.061)">
                  <path id="Path_20239" data-name="Path 20239" d="M387.949,366.169v-1.988h.822v1.958c0,.675.294.953.791.953s.791-.279.791-.953v-1.958h.812v1.988a1.608,1.608,0,1,1-3.215,0Z" transform="translate(-387.949 -364.181)" fill="#fff" />
                </g>
                <g id="Group_15400" data-name="Group 15400" transform="translate(7.646 0.061)">
                  <path id="Path_20240" data-name="Path 20240" d="M403.46,366.762c0,.614-.487.969-1.42.969H400.2v-3.55h1.734c.887,0,1.344.37,1.344.923a.854.854,0,0,1-.472.781A.876.876,0,0,1,403.46,366.762Zm-2.44-1.963v.837h.817c.4,0,.619-.142.619-.421s-.218-.416-.619-.416Zm1.613,1.876c0-.3-.228-.441-.654-.441h-.959v.877h.959C402.4,367.112,402.633,366.98,402.633,366.676Z" transform="translate(-400.204 -364.181)" fill="#fff" />
                </g>
                <g id="Group_15401" data-name="Group 15401" transform="translate(11.527 0.061)">
                  <path id="Path_20241" data-name="Path 20241" d="M412.01,364.181h.822v2.881h1.78v.669h-2.6Z" transform="translate(-412.01 -364.181)" fill="#fff" />
                </g>
                <g id="Group_15402" data-name="Group 15402" transform="translate(14.592 0.061)">
                  <path id="Path_20242" data-name="Path 20242" d="M421.333,364.181h.821v3.55h-.821Z" transform="translate(-421.333 -364.181)" fill="#fff" />
                </g>
                <g id="Group_15403" data-name="Group 15403" transform="translate(15.977)">
                  <path id="Path_20243" data-name="Path 20243" d="M425.545,367.257l.279-.619a2.087,2.087,0,0,0,1.172.37c.487,0,.685-.162.685-.38,0-.664-2.064-.208-2.064-1.526,0-.6.487-1.106,1.5-1.106a2.383,2.383,0,0,1,1.232.314l-.253.624a2.007,2.007,0,0,0-.984-.279c-.487,0-.674.183-.674.406,0,.654,2.064.2,2.064,1.506,0,.593-.492,1.1-1.506,1.1A2.531,2.531,0,0,1,425.545,367.257Z" transform="translate(-425.545 -363.996)" fill="#fff" />
                </g>
                <g id="Group_15404" data-name="Group 15404" transform="translate(19.493 0.061)">
                  <path id="Path_20244" data-name="Path 20244" d="M439.5,364.181v3.55h-.822v-1.456h-1.613v1.456h-.822v-3.55h.822v1.4h1.613v-1.4Z" transform="translate(-436.241 -364.181)" fill="#fff" />
                </g>
              </g>
            </g>
          </g>
          <g id="Cursor" transform="translate(165.783 138.179)">
            <g id="Group_15448" data-name="Group 15448">
              <g id="Group_15435" data-name="Group 15435" transform="translate(0 3.615)">
                <g id="Group_15414" data-name="Group 15414">
                  <g id="Group_15409" data-name="Group 15409" transform="translate(0.036 0.049)">
                    <g id="Group_15408" data-name="Group 15408">
                      <g id="Group_15407" data-name="Group 15407">
                        <path id="Path_20245" data-name="Path 20245" d="M462.465,372.363a5.164,5.164,0,0,1,.575,1.769H464.1l4.456-.078-.032.079s.726-3.417.859-4.434c.109-.839.628-2.844,0-3.729a.925.925,0,0,0-1.02-.341.724.724,0,0,0-.511.56s-.054-1.186-.9-1.2-.88.647-.88.647-.233-1.353-1.18-1.342a.909.909,0,0,0-.783.658V362.39a.984.984,0,0,0-.921-1,.957.957,0,0,0-.993.944l-.076,5.956-1.447-1.855a.884.884,0,0,0-1.393.171,1.418,1.418,0,0,0,.278,1.345C459.951,368.554,462.465,372.363,462.465,372.363Z" transform="translate(-459.208 -361.393)" fill="#ebebeb" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15413" data-name="Group 15413">
                    <g id="Group_15412" data-name="Group 15412">
                      <g id="Group_15411" data-name="Group 15411">
                        <g id="Group_15410" data-name="Group 15410">
                          <path id="Path_20246" data-name="Path 20246" d="M462.392,372.263s-.025-.031-.069-.1l-.195-.286-.742-1.1-1.172-1.756-.732-1.1a2.244,2.244,0,0,1-.322-.655,1.225,1.225,0,0,1,.007-.773l0,.006a.619.619,0,0,1,.321-.345,1.113,1.113,0,0,1,.465-.119.892.892,0,0,1,.483.113,1.1,1.1,0,0,1,.1.076c.031.03.061.063.089.095l.154.2,1.292,1.652-.078.026c.019-1.662.041-3.484.064-5.421l0-.365a1.853,1.853,0,0,1,.026-.376,1,1,0,0,1,1.828-.31,1.071,1.071,0,0,1,.145.374,2.182,2.182,0,0,1,.018.394q0,.388,0,.779,0,.783,0,1.581l-.1-.015a.989.989,0,0,1,.438-.567,1,1,0,0,1,.288-.112.439.439,0,0,1,.158-.011.926.926,0,0,1,.154.017.989.989,0,0,1,.525.3,2.229,2.229,0,0,1,.5,1.06l-.1.006a.737.737,0,0,1,.439-.608,1.047,1.047,0,0,1,.369-.084,1.058,1.058,0,0,1,.188,0l.095.01.092.028a.915.915,0,0,1,.528.508,2.013,2.013,0,0,1,.176.7l-.1-.009a.78.78,0,0,1,.48-.572.976.976,0,0,1,1.048.227,1.338,1.338,0,0,1,.206.305,2.314,2.314,0,0,1,.179.69,10.465,10.465,0,0,1-.253,2.676c-.119.854-.288,1.666-.44,2.439l-.457,2.2-.072-.022.032-.079.036.052-4.456.065.024-.025h0v.025h-.025l-1.061,0h-.018l0-.018a5.278,5.278,0,0,0-.355-1.333c-.06-.146-.111-.255-.147-.327s-.052-.111-.052-.111a3.388,3.388,0,0,1,.219.43,5.1,5.1,0,0,1,.376,1.337l-.02-.018,1.061,0-.025.025h0v-.025h.025l4.455-.091h.057l-.021.053-.032.079-.072-.022.448-2.2c.15-.774.316-1.583.433-2.437a10.441,10.441,0,0,0,.247-2.651,2.235,2.235,0,0,0-.172-.659,1.259,1.259,0,0,0-.188-.279.877.877,0,0,0-.941-.2.679.679,0,0,0-.419.5l-.072.342-.027-.351a1.913,1.913,0,0,0-.167-.66.814.814,0,0,0-.469-.455,1.023,1.023,0,0,0-.67.039.638.638,0,0,0-.378.519l-.032.335-.07-.328a2.132,2.132,0,0,0-.472-1.007.787.787,0,0,0-1-.178.886.886,0,0,0-.392.509l-.1.313v-1.909q0-.392,0-.779a2.093,2.093,0,0,0-.016-.376.966.966,0,0,0-.131-.338.9.9,0,0,0-1.645.278,1.766,1.766,0,0,0-.024.356c0,.122,0,.243-.005.365-.027,1.937-.052,3.758-.075,5.421l0,.124-.076-.1-1.287-1.655a1.277,1.277,0,0,0-.325-.348.821.821,0,0,0-.441-.1,1.044,1.044,0,0,0-.434.109.55.55,0,0,0-.285.3h0l0,.005a1.164,1.164,0,0,0-.006.723,2.184,2.184,0,0,0,.31.637l.726,1.1,1.158,1.766.726,1.115.186.291C462.373,372.228,462.392,372.263,462.392,372.263Z" transform="translate(-459.099 -361.243)" fill="#263238" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15422" data-name="Group 15422" transform="translate(3.046 12.671)">
                  <g id="Group_15417" data-name="Group 15417" transform="translate(0.051 0.052)">
                    <g id="Group_15416" data-name="Group 15416">
                      <g id="Group_15415" data-name="Group 15415">
                        <rect id="Rectangle_18381" data-name="Rectangle 18381" width="7.114" height="1.589" rx="0.795" fill="#ebebeb" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15421" data-name="Group 15421">
                    <g id="Group_15420" data-name="Group 15420">
                      <g id="Group_15419" data-name="Group 15419">
                        <g id="Group_15418" data-name="Group 15418">
                          <path id="Path_20247" data-name="Path 20247" d="M474.763,401.428c0-.006.057,0,.16-.028a.763.763,0,0,0,.549-.516.928.928,0,0,0,.021-.387.737.737,0,0,0-.627-.613l-5.682.007a.724.724,0,0,0-.629.373.828.828,0,0,0-.01.722.72.72,0,0,0,.57.39c.243.008.5,0,.734.005l2.557.011,1.724.016.468.01a.969.969,0,0,1,.163.01.946.946,0,0,1-.163.01l-.468.01-1.724.016-2.557.011c-.243,0-.483,0-.744,0a.817.817,0,0,1-.651-.442.925.925,0,0,1,.009-.817.825.825,0,0,1,.719-.427c2.223,0,4.227,0,5.692.024a.8.8,0,0,1,.673.677.967.967,0,0,1-.031.41.794.794,0,0,1-.178.3.766.766,0,0,1-.413.226A.53.53,0,0,1,474.763,401.428Z" transform="translate(-468.365 -399.787)" fill="#263238" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15426" data-name="Group 15426" transform="translate(4.83 3.485)">
                  <g id="Group_15425" data-name="Group 15425">
                    <g id="Group_15424" data-name="Group 15424">
                      <g id="Group_15423" data-name="Group 15423">
                        <path id="Path_20248" data-name="Path 20248" d="M473.844,374.15a12.893,12.893,0,0,1,0-2.305,12.977,12.977,0,0,1,0,2.305Z" transform="translate(-473.792 -371.845)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15430" data-name="Group 15430" transform="translate(6.815 4.263)">
                  <g id="Group_15429" data-name="Group 15429">
                    <g id="Group_15428" data-name="Group 15428">
                      <g id="Group_15427" data-name="Group 15427">
                        
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15434" data-name="Group 15434" transform="translate(8.625 4.84)">
                  <g id="Group_15433" data-name="Group 15433">
                    <g id="Group_15432" data-name="Group 15432">
                      <g id="Group_15431" data-name="Group 15431">
                    
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15439" data-name="Group 15439" transform="translate(0.476 2.487)">
                <g id="Group_15438" data-name="Group 15438">
                  <g id="Group_15437" data-name="Group 15437">
                    <g id="Group_15436" data-name="Group 15436">
                      <path id="Path_20251" data-name="Path 20251" d="M462.678,358.9a13.988,13.988,0,0,1-2.13-1.087,13.863,13.863,0,0,1,2.13,1.087Z" transform="translate(-460.548 -357.81)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15443" data-name="Group 15443" transform="translate(3.092)">
                <g id="Group_15442" data-name="Group 15442">
                  <g id="Group_15441" data-name="Group 15441">
                    <g id="Group_15440" data-name="Group 15440">
                      <path id="Path_20252" data-name="Path 20252" d="M468.985,353.278a22.84,22.84,0,0,1-.475-3.033,22.888,22.888,0,0,1,.475,3.033Z" transform="translate(-468.505 -350.245)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15447" data-name="Group 15447" transform="translate(4.771 1.13)">
                <g id="Group_15446" data-name="Group 15446">
                  <g id="Group_15445" data-name="Group 15445">
                    <g id="Group_15444" data-name="Group 15444">
                      <path id="Path_20253" data-name="Path 20253" d="M473.614,355.723a15.105,15.105,0,0,1,1.428-2.04,15.071,15.071,0,0,1-1.428,2.04Z" transform="translate(-473.613 -353.683)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Briefcase" transform="translate(26.564 154.831)">
            <g id="Group_15470" data-name="Group 15470">
              <g id="Group_15451" data-name="Group 15451" transform="translate(0 2.487)">
                <g id="Group_15450" data-name="Group 15450" transform="translate(0 0)">
                  <g id="Group_15449" data-name="Group 15449">
                    <path id="Rectangle_18382" data-name="Rectangle 18382" d="M6.189,0H21.6a2.854,2.854,0,0,1,2.854,2.854V13.9a2.577,2.577,0,0,1-2.577,2.577H6.189A6.189,6.189,0,0,1,0,10.289v-4.1A6.189,6.189,0,0,1,6.189,0Z" transform="translate(24.455 16.478) rotate(180)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15454" data-name="Group 15454" transform="translate(0 2.487)" opacity="0.4">
                <g id="Group_15453" data-name="Group 15453" transform="translate(0 0)">
                  <g id="Group_15452" data-name="Group 15452">
                    <path id="Rectangle_18383" data-name="Rectangle 18383" d="M6.189,0H21.6a2.854,2.854,0,0,1,2.854,2.854V13.9a2.577,2.577,0,0,1-2.577,2.577H6.189A6.189,6.189,0,0,1,0,10.289v-4.1A6.189,6.189,0,0,1,6.189,0Z" transform="translate(24.455 16.478) rotate(180)" />
                  </g>
                </g>
              </g>
              <g id="Group_15457" data-name="Group 15457" transform="translate(3.634 2.487)">
                <g id="Group_15456" data-name="Group 15456" transform="translate(0 0)">
                  <g id="Group_15455" data-name="Group 15455">
                    <path id="Rectangle_18384" data-name="Rectangle 18384" d="M2.892,0H24.455a0,0,0,0,1,0,0V16.478a0,0,0,0,1,0,0H4.23A4.23,4.23,0,0,1,0,12.248V2.892A2.892,2.892,0,0,1,2.892,0Z" transform="translate(24.455 16.478) rotate(180)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15461" data-name="Group 15461" transform="translate(3.545 2.719)">
                <g id="Group_15460" data-name="Group 15460">
                  <g id="Group_15459" data-name="Group 15459">
                    <g id="Group_15458" data-name="Group 15458">
                      <path id="Path_20254" data-name="Path 20254" d="M46.466,425.5c-.043,0-.078-3.656-.078-8.164s.035-8.165.078-8.165.078,3.655.078,8.165S46.509,425.5,46.466,425.5Z" transform="translate(-46.388 -409.168)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15465" data-name="Group 15465" transform="translate(9.531)">
                <g id="Group_15464" data-name="Group 15464">
                  <g id="Group_15463" data-name="Group 15463">
                    <g id="Group_15462" data-name="Group 15462">
                      <path id="Path_20255" data-name="Path 20255" d="M64.6,403.181s.019-.036.067-.1.117-.148.22-.25a5.856,5.856,0,0,1,.936-.792,6.4,6.4,0,0,1,7.6.215,5.865,5.865,0,0,1,.89.844c.1.108.159.2.205.262s.066.1.062.1a10.153,10.153,0,0,0-1.224-1.116,6.487,6.487,0,0,0-7.474-.211A10.13,10.13,0,0,0,64.6,403.181Z" transform="translate(-64.596 -400.898)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15469" data-name="Group 15469" transform="translate(3.472 4.844)">
                <g id="Group_15468" data-name="Group 15468">
                  <g id="Group_15467" data-name="Group 15467">
                    <g id="Group_15466" data-name="Group 15466">
                      <path id="Path_20256" data-name="Path 20256" d="M46.167,415.632a.387.387,0,0,1,.021.088l.044.26c.02.114.037.256.071.421l.128.569a11.608,11.608,0,0,0,1.468,3.39,11.758,11.758,0,0,0,10.33,5.449,12.861,12.861,0,0,0,6.389-1.841,13.965,13.965,0,0,0,4.009-3.71,14.849,14.849,0,0,0,1.777-3.249c.156-.41.272-.731.337-.953l.084-.25a.394.394,0,0,1,.034-.084.386.386,0,0,1-.018.088l-.069.254c-.057.225-.163.55-.311.966a14.3,14.3,0,0,1-1.745,3.292,13.921,13.921,0,0,1-4.024,3.768,12.919,12.919,0,0,1-6.461,1.874,12.171,12.171,0,0,1-6.5-1.685,11.99,11.99,0,0,1-3.923-3.86,11.293,11.293,0,0,1-1.434-3.435q-.065-.322-.115-.575c-.029-.167-.041-.311-.057-.425s-.022-.194-.029-.262A.4.4,0,0,1,46.167,415.632Z" transform="translate(-46.166 -415.632)" fill="#455a64" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Plant" transform="translate(216.41 109.511)">
            <g id="Group_15498" data-name="Group 15498">
              <g id="Group_15472" data-name="Group 15472" transform="translate(18.716 1.499)">
                <g id="Group_15471" data-name="Group 15471">
                  <path id="Path_20257" data-name="Path 20257" d="M682.787,267.6a19.216,19.216,0,0,0-7.609,7.851,57.319,57.319,0,0,0-4.132,10.272l-1.011,18.11c3.82-6.5,6.885-14.136,7.713-21.627l-2.541-.226a6.081,6.081,0,0,0,4.044-2.959,18.015,18.015,0,0,0,1.836-4.814l-3.1.461A11.492,11.492,0,0,0,682.787,267.6Z" transform="translate(-670.035 -267.597)" fill="#455a64" />
                </g>
              </g>
              <g id="Group_15475" data-name="Group 15475" transform="translate(18.716 1.499)" opacity="0.3">
                <g id="Group_15474" data-name="Group 15474">
                  <g id="Group_15473" data-name="Group 15473">
                    <path id="Path_20258" data-name="Path 20258" d="M682.787,267.6a19.216,19.216,0,0,0-7.609,7.851,57.319,57.319,0,0,0-4.132,10.272l-1.011,18.11c3.82-6.5,6.885-14.136,7.713-21.627l-2.541-.226a6.081,6.081,0,0,0,4.044-2.959,18.015,18.015,0,0,0,1.836-4.814l-3.1.461A11.492,11.492,0,0,0,682.787,267.6Z" transform="translate(-670.035 -267.597)" fill="#95b44c" />
                  </g>
                </g>
              </g>
              <g id="Group_15477" data-name="Group 15477" transform="translate(9.94)">
                <g id="Group_15476" data-name="Group 15476">
                  <path id="Path_20259" data-name="Path 20259" d="M651.549,305.012s-8.29-9.922-8.194-19.395H646.7s-3.637-2.392-3.35-3.732.383-6.41.383-6.41l3.062.765s-2.3-1.148-2.583-2.966.67-10.238.67-10.238,3.732,3.923,4.879,7.941,4.162,8.707,3.277,20.953S651.549,305.012,651.549,305.012Z" transform="translate(-643.338 -263.037)" fill="#95b44c" />
                </g>
              </g>
              <g id="Group_15479" data-name="Group 15479" transform="translate(22.351 10.803)">
                <g id="Group_15478" data-name="Group 15478">
                  <path id="Path_20260" data-name="Path 20260" d="M681.094,328.007s8.982-5.983,10.977-13.619l-2.692-.733s3.448-1.127,3.509-2.267,1.094-5.237,1.094-5.237l-2.629-.055s2.1-.421,2.726-1.82,1.7-8.377,1.7-8.377a19.407,19.407,0,0,0-5.66,5.317c-1.8,2.98-5.251,6.09-7.219,16.129S681.094,328.007,681.094,328.007Z" transform="translate(-681.09 -295.899)" fill="#95b44c" />
                </g>
              </g>
              <g id="Group_15482" data-name="Group 15482" transform="translate(13.752 8.651)">
                <g id="Group_15481" data-name="Group 15481">
                  <g id="Group_15480" data-name="Group 15480">
                    <path id="Path_20261" data-name="Path 20261" d="M654.933,289.353a.494.494,0,0,1,.031.1l.073.305.264,1.177c.115.511.249,1.138.395,1.868s.32,1.559.489,2.481c.356,1.839.731,4.039,1.117,6.486s.748,5.147,1.08,7.987.577,5.554.771,8.025.319,4.7.392,6.57c.046.936.068,1.783.09,2.527s.037,1.384.042,1.908.009.919.011,1.206c0,.13,0,.234,0,.314a.514.514,0,0,1-.006.107.5.5,0,0,1-.011-.107c0-.08-.009-.183-.015-.314-.01-.287-.025-.69-.043-1.205s-.036-1.164-.071-1.907-.062-1.59-.115-2.524c-.089-1.871-.238-4.1-.429-6.564s-.46-5.178-.784-8.017-.7-5.534-1.065-7.982-.74-4.647-1.08-6.488c-.161-.922-.325-1.753-.464-2.484s-.261-1.36-.366-1.873L655,289.768c-.023-.128-.042-.23-.056-.309A.488.488,0,0,1,654.933,289.353Z" transform="translate(-654.932 -289.353)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15484" data-name="Group 15484" transform="translate(0 24.899)">
                <g id="Group_15483" data-name="Group 15483">
                  <path id="Path_20262" data-name="Path 20262" d="M630.1,361.929s-7.586-8.608-9.942-13.811l1.779-.76a4.611,4.611,0,0,1-3.609-1.183,13.657,13.657,0,0,1-2.453-3.038l2.343-.4a8.709,8.709,0,0,1-5.118-3.965,14.564,14.564,0,0,1,7.326,3.871,36.491,36.491,0,0,1,4.439,5.144,17.507,17.507,0,0,1,1.724,2.834C627.865,353.262,630.107,358.768,630.1,361.929Z" transform="translate(-613.101 -338.777)" fill="#95b44c" />
                </g>
              </g>
              <g id="Group_15487" data-name="Group 15487" transform="translate(20.341 15.813)">
                <g id="Group_15486" data-name="Group 15486">
                  <g id="Group_15485" data-name="Group 15485">
                    <path id="Path_20263" data-name="Path 20263" d="M688.086,311.14a.381.381,0,0,1-.034.088l-.116.25-.46.956c-.406.827-.981,2.029-1.678,3.521-1.395,2.983-3.232,7.147-5.046,11.833s-3.252,9.006-4.227,12.151c-.489,1.572-.872,2.849-1.128,3.734l-.3,1.017-.083.263a.366.366,0,0,1-.034.088.4.4,0,0,1,.017-.093l.066-.268.271-1.026c.236-.891.6-2.173,1.076-3.751.946-3.156,2.371-7.484,4.184-12.178s3.673-8.851,5.1-11.822c.711-1.487,1.3-2.682,1.728-3.5l.489-.941.131-.243A.37.37,0,0,1,688.086,311.14Z" transform="translate(-674.977 -311.14)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15490" data-name="Group 15490" transform="translate(12.089 37.025)">
                <g id="Group_15489" data-name="Group 15489">
                  <g id="Group_15488" data-name="Group 15488">
                    <path id="Path_20264" data-name="Path 20264" d="M655.43,390.378a.6.6,0,0,1-.038-.158l-.076-.457c-.058-.4-.158-.97-.3-1.674s-.333-1.536-.581-2.451-.572-1.907-.955-2.931-.81-1.977-1.221-2.831-.821-1.6-1.184-2.224-.664-1.116-.882-1.453l-.245-.393a.572.572,0,0,1-.076-.144.58.58,0,0,1,.1.124l.272.375c.236.326.556.813.931,1.428s.794,1.364,1.221,2.216.848,1.813,1.239,2.841.7,2.031.947,2.95.426,1.76.548,2.47.206,1.286.245,1.687l.044.461A.571.571,0,0,1,655.43,390.378Z" transform="translate(-649.874 -375.663)" fill="#263238" />
                  </g>
                </g>
              </g>
              <g id="Group_15492" data-name="Group 15492" transform="translate(11.051 49.715)">
                <g id="Group_15491" data-name="Group 15491">
                  <rect id="Rectangle_18385" data-name="Rectangle 18385" width="16.604" height="3.387" fill="#ff725e" />
                </g>
              </g>
              <g id="Group_15494" data-name="Group 15494" transform="translate(12.634 53.102)">
                <g id="Group_15493" data-name="Group 15493">
                  <path id="Path_20265" data-name="Path 20265" d="M651.531,424.568l1.8,11.392H663.36l1.674-11.392Z" transform="translate(-651.531 -424.568)" fill="#ff725e" />
                </g>
              </g>
              <g id="Group_15497" data-name="Group 15497" transform="translate(12.607 53.016)">
                <g id="Group_15496" data-name="Group 15496">
                  <g id="Group_15495" data-name="Group 15495">
                    <path id="Path_20266" data-name="Path 20266" d="M665.48,424.393c0,.047-3.141.086-7.015.086s-7.015-.038-7.015-.086,3.14-.085,7.015-.085S665.48,424.346,665.48,424.393Z" transform="translate(-651.45 -424.308)" fill="#263238" />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Character" transform="translate(31.026 69.733)">
            <g id="Group_15954" data-name="Group 15954" transform="translate(0)">
              <g id="Group_15527" data-name="Group 15527" transform="translate(0 35.314)">
                <g id="Group_15501" data-name="Group 15501">
                  <g id="Group_15500" data-name="Group 15500">
                    <g id="Group_15499" data-name="Group 15499">
                      <path id="Path_20267" data-name="Path 20267" d="M49.643,284.356,49.179,260.6a10.931,10.931,0,0,1,10.913-11.145h0a10.931,10.931,0,0,1,10.946,10.875l.124,24.023-21.519.919" transform="translate(-49.176 -249.459)" fill="#455a64" />
                    </g>
                  </g>
                </g>
                <g id="Group_15504" data-name="Group 15504" transform="translate(0.466 34.897)">
                  <g id="Group_15503" data-name="Group 15503">
                    <g id="Group_15502" data-name="Group 15502">
                      <path id="Path_20268" data-name="Path 20268" d="M50.6,359.666H84.069a3.7,3.7,0,0,0-3.748-3.924L50.6,355.614Z" transform="translate(-50.595 -355.614)" fill="#455a64" />
                    </g>
                  </g>
                </g>
                <g id="Group_15507" data-name="Group 15507" transform="translate(28.154 38.95)">
                  <g id="Group_15506" data-name="Group 15506" transform="translate(0)">
                    <g id="Group_15505" data-name="Group 15505">
                      <rect id="Rectangle_18386" data-name="Rectangle 18386" width="2.351" height="29.8" transform="translate(2.351 29.8) rotate(180)" fill="#455a64" />
                    </g>
                  </g>
                </g>
                <g id="Group_15510" data-name="Group 15510" transform="translate(3.121 38.95)">
                  <g id="Group_15509" data-name="Group 15509" transform="translate(0)">
                    <g id="Group_15508" data-name="Group 15508">
                      <rect id="Rectangle_18387" data-name="Rectangle 18387" width="2.351" height="29.8" transform="translate(2.351 29.8) rotate(180)" fill="#455a64" />
                    </g>
                  </g>
                </g>
                <g id="Group_15514" data-name="Group 15514" transform="translate(3.198 34.947)">
                  <g id="Group_15513" data-name="Group 15513">
                    <g id="Group_15512" data-name="Group 15512">
                      <g id="Group_15511" data-name="Group 15511">
                        <path id="Path_20269" data-name="Path 20269" d="M58.905,355.843c0-.043,6.227-.078,13.907-.078s13.908.035,13.908.078-6.226.078-13.908.078S58.905,355.886,58.905,355.843Z" transform="translate(-58.905 -355.765)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15518" data-name="Group 15518" transform="translate(1.033 38.886)">
                  <g id="Group_15517" data-name="Group 15517">
                    <g id="Group_15516" data-name="Group 15516">
                      <g id="Group_15515" data-name="Group 15515">
                        <path id="Path_20270" data-name="Path 20270" d="M52.318,367.825c0-.043,7.318-.078,16.344-.078s16.345.035,16.345.078-7.316.078-16.345.078S52.318,367.868,52.318,367.825Z" transform="translate(-52.318 -367.747)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15522" data-name="Group 15522" transform="translate(2.82 34.703)">
                  <g id="Group_15521" data-name="Group 15521">
                    <g id="Group_15520" data-name="Group 15520">
                      <g id="Group_15519" data-name="Group 15519">
                        <path id="Path_20271" data-name="Path 20271" d="M57.755,355.023" transform="translate(-57.755 -355.023)" fill="none" stroke="#4e585d" strokeMiterlimit="10" strokeWidth="0.05" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15526" data-name="Group 15526" transform="translate(2.742 4.231)">
                  <g id="Group_15525" data-name="Group 15525">
                    <g id="Group_15524" data-name="Group 15524">
                      <g id="Group_15523" data-name="Group 15523">
                        <path id="Path_20272" data-name="Path 20272" d="M57.6,262.328c.043,0,.078,6.78.078,15.141s-.035,15.143-.078,15.143-.078-6.778-.078-15.143S57.553,262.328,57.6,262.328Z" transform="translate(-57.518 -262.328)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15922" data-name="Group 15922" transform="translate(2.202)">
                <g id="Group_15595" data-name="Group 15595" transform="translate(11.599 56.845)">
                  <g id="Group_15538" data-name="Group 15538">
                    <g id="Group_15530" data-name="Group 15530">
                      <g id="Group_15529" data-name="Group 15529">
                        <g id="Group_15528" data-name="Group 15528">
                          <path id="Path_20273" data-name="Path 20273" d="M100.243,314.991s18.836-.08,20.328,0c2.656.142,4.436,3.108,4.791,4.643s8.587,25.208,8.587,25.208l-6.4,4.138-8.582-19.361-4.318-7.512-23.492,4.1Z" transform="translate(-91.161 -314.955)" fill="#ffceaf" />
                        </g>
                      </g>
                    </g>
                    <g id="Group_15533" data-name="Group 15533" transform="translate(6.495 5.854)">
                      <g id="Group_15532" data-name="Group 15532">
                        <g id="Group_15531" data-name="Group 15531">
                          <path id="Path_20274" data-name="Path 20274" d="M128.036,333.367a6.944,6.944,0,0,1,5.354,2.781c1.1,1.635.716,4.557.738,6.762.03,3-.751,26.3-.751,26.3a7.4,7.4,0,0,1-7.4.7l-1.913-25.788.493-3.847-12.848.284s-2.287-4.282.893-7.679C113.015,332.443,128.036,333.367,128.036,333.367Z" transform="translate(-110.917 -332.763)" fill="#ffceaf" />
                        </g>
                      </g>
                    </g>
                    <g id="Group_15537" data-name="Group 15537" transform="translate(25.235 6.583)">
                      <g id="Group_15536" data-name="Group 15536">
                        <g id="Group_15535" data-name="Group 15535">
                          <g id="Group_15534" data-name="Group 15534">
                            <path id="Path_20275" data-name="Path 20275" d="M167.924,334.982a.461.461,0,0,1,.1.01l.283.044a4.27,4.27,0,0,1,1.037.369,5.29,5.29,0,0,1,1.4,1.041,6.761,6.761,0,0,1,1.278,1.921,7.878,7.878,0,0,1,.64,2.721,21.339,21.339,0,0,1-.087,3.207c-.1,1.124-.156,2.3-.2,3.528s-.083,2.5-.126,3.8c-.157,5.2-.3,9.9-.4,13.322-.055,1.7-.1,3.073-.131,4.037-.018.468-.033.836-.043,1.1-.006.119-.011.213-.015.285a.457.457,0,0,1-.011.1.473.473,0,0,1-.005-.1c0-.073,0-.167,0-.286l.014-1.1c.019-.964.047-2.341.081-4.038.078-3.41.195-8.121.357-13.324.044-1.3.088-2.57.13-3.8s.1-2.412.209-3.534a21.546,21.546,0,0,0,.1-3.186,7.821,7.821,0,0,0-.612-2.685,6.732,6.732,0,0,0-1.24-1.905,5.331,5.331,0,0,0-1.361-1.048A4.978,4.978,0,0,0,167.924,334.982Z" transform="translate(-167.924 -334.981)" fill="#6f4c47" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15551" data-name="Group 15551" transform="translate(21.176 41.97)">
                    <g id="Group_15550" data-name="Group 15550">
                      <g id="Group_15549" data-name="Group 15549">
                        <g id="Group_15543" data-name="Group 15543">
                          <g id="Group_15542" data-name="Group 15542">
                            <g id="Group_15541" data-name="Group 15541">
                              <g id="Group_15540" data-name="Group 15540">
                                <g id="Group_15539" data-name="Group 15539">
                                  <path id="Path_20276" data-name="Path 20276" d="M163.353,442.714l.007.474s8.062,3.145,8.163,4.668l-15.946.077.191-5.307A9.123,9.123,0,0,0,163.353,442.714Z" transform="translate(-155.577 -442.625)" fill="#92899d" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                        <g id="Group_15548" data-name="Group 15548" transform="translate(0 4.031)">
                          <g id="Group_15547" data-name="Group 15547">
                            <g id="Group_15546" data-name="Group 15546">
                              <g id="Group_15545" data-name="Group 15545">
                                <g id="Group_15544" data-name="Group 15544">
                                  <path id="Path_20277" data-name="Path 20277" d="M155.577,456.163l.046-1.277,15.266.394s.712.305.634.806Z" transform="translate(-155.577 -454.886)" fill="#e0e0e0" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15564" data-name="Group 15564" transform="translate(35.393 28.902)">
                    <g id="Group_15563" data-name="Group 15563">
                      <g id="Group_15562" data-name="Group 15562">
                        <g id="Group_15556" data-name="Group 15556">
                          <g id="Group_15555" data-name="Group 15555">
                            <g id="Group_15554" data-name="Group 15554">
                              <g id="Group_15553" data-name="Group 15553">
                                <g id="Group_15552" data-name="Group 15552">
                                  <path id="Path_20278" data-name="Path 20278" d="M205.909,402.872l.181.438s8.654-.048,9.309,1.33L200.6,410.59l-1.779-5A9.122,9.122,0,0,0,205.909,402.872Z" transform="translate(-198.825 -402.872)" fill="#92899d" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                        <g id="Group_15561" data-name="Group 15561" transform="translate(1.351 1.253)">
                          <g id="Group_15560" data-name="Group 15560">
                            <g id="Group_15559" data-name="Group 15559">
                              <g id="Group_15558" data-name="Group 15558">
                                <g id="Group_15557" data-name="Group 15557">
                                  <path id="Path_20279" data-name="Path 20279" d="M203.362,413.148l-.428-1.2,14.336-5.261s.774.021.886.515Z" transform="translate(-202.934 -406.683)" fill="#e0e0e0" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15567" data-name="Group 15567" transform="translate(43.024 29.252)">
                    <g id="Group_15566" data-name="Group 15566" transform="translate(0)">
                      <g id="Group_15565" data-name="Group 15565">
                        <path id="Path_20280" data-name="Path 20280" d="M222.27,405.841c-.018.01-.094-.085-.158-.267a1.585,1.585,0,0,1,.241-1.434c.12-.152.222-.216.237-.2a2.365,2.365,0,0,0-.32,1.9Z" transform="translate(-222.036 -403.936)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15570" data-name="Group 15570" transform="translate(42.242 29.356)">
                    <g id="Group_15569" data-name="Group 15569" transform="translate(0)">
                      <g id="Group_15568" data-name="Group 15568">
                        <path id="Path_20281" data-name="Path 20281" d="M219.827,406.2a1.716,1.716,0,0,1,.331-1.943,3.543,3.543,0,0,0-.331,1.943Z" transform="translate(-219.657 -404.253)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15573" data-name="Group 15573" transform="translate(44.156 29.418)">
                    <g id="Group_15572" data-name="Group 15572" transform="translate(0)">
                      <g id="Group_15571" data-name="Group 15571">
                        <path id="Path_20282" data-name="Path 20282" d="M225.868,406.074a1.368,1.368,0,0,1-.205-1.629c.048.016-.06.38,0,.827S225.91,406.047,225.868,406.074Z" transform="translate(-225.48 -404.444)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15576" data-name="Group 15576" transform="translate(42.702 27.534)">
                    <g id="Group_15575" data-name="Group 15575" transform="translate(0)">
                      <g id="Group_15574" data-name="Group 15574">
                        <path id="Path_20283" data-name="Path 20283" d="M222.019,400.557c-.009.017-.222-.093-.44-.4a3.042,3.042,0,0,1-.311-.565c-.048-.111-.094-.228-.14-.35a1.032,1.032,0,0,1-.064-.205.307.307,0,0,1,.073-.262.24.24,0,0,1,.288-.035.531.531,0,0,1,.173.156,1.854,1.854,0,0,1,.2.333,1.946,1.946,0,0,1,.177.628,1.019,1.019,0,0,1-.062.589c-.028,0,.006-.227-.058-.572a2.114,2.114,0,0,0-.2-.575,1.878,1.878,0,0,0-.193-.3c-.069-.1-.176-.152-.206-.1-.055.052-.024.166.026.29l.129.347a3.828,3.828,0,0,0,.266.559C221.86,400.4,222.036,400.536,222.019,400.557Z" transform="translate(-221.059 -398.71)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15579" data-name="Group 15579" transform="translate(43.581 27.732)">
                    <g id="Group_15578" data-name="Group 15578" transform="translate(0)">
                      <g id="Group_15577" data-name="Group 15577">
                        <path id="Path_20284" data-name="Path 20284" d="M223.9,400.877c.006.007-.012.034-.057.084L223.8,401l-.009-.058a1.95,1.95,0,0,1,.039-.67,2.467,2.467,0,0,1,.168-.5,2.621,2.621,0,0,1,.141-.263.508.508,0,0,1,.115-.138.259.259,0,0,1,.216-.052.226.226,0,0,1,.164.226.779.779,0,0,1-.03.205,2.163,2.163,0,0,1-.117.344,2.055,2.055,0,0,1-.325.516c-.229.263-.425.36-.436.344s.148-.152.341-.419a2.311,2.311,0,0,0,.275-.5,2.24,2.24,0,0,0,.1-.321c.035-.117.028-.233-.01-.226-.093-.032-.209.214-.287.356a2.765,2.765,0,0,0-.181.464,3.927,3.927,0,0,0-.12.635l-.043-.02C223.861,400.884,223.89,400.871,223.9,400.877Z" transform="translate(-223.73 -399.313)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15582" data-name="Group 15582" transform="translate(28.795 42.884)">
                    <g id="Group_15581" data-name="Group 15581">
                      <g id="Group_15580" data-name="Group 15580">
                        <path id="Path_20285" data-name="Path 20285" d="M178.774,446.871c-.021,0-.036-.122.005-.31a1.585,1.585,0,0,1,.956-1.1c.181-.067.3-.068.306-.048a2.367,2.367,0,0,0-1.268,1.454Z" transform="translate(-178.753 -445.405)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15585" data-name="Group 15585" transform="translate(28.007 42.539)">
                    <g id="Group_15584" data-name="Group 15584">
                      <g id="Group_15583" data-name="Group 15583">
                        <path id="Path_20286" data-name="Path 20286" d="M176.369,445.847a1.717,1.717,0,0,1,1.3-1.483,8.67,8.67,0,0,0-.754.649A8.575,8.575,0,0,0,176.369,445.847Z" transform="translate(-176.357 -444.357)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15588" data-name="Group 15588" transform="translate(29.918 43.431)">
                    <g id="Group_15587" data-name="Group 15587">
                      <g id="Group_15586" data-name="Group 15586">
                        <path id="Path_20287" data-name="Path 20287" d="M182.219,448.568a1.061,1.061,0,0,1,.089-.861c.2-.458.567-.675.588-.635s-.249.293-.432.706S182.269,448.567,182.219,448.568Z" transform="translate(-182.168 -447.068)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15591" data-name="Group 15591" transform="translate(29.917 41.063)">
                    <g id="Group_15590" data-name="Group 15590">
                      <g id="Group_15589" data-name="Group 15589">
                        <path id="Path_20288" data-name="Path 20288" d="M182.338,441.85a.968.968,0,0,1-.167-.569,3.077,3.077,0,0,1,.031-.644c.017-.12.039-.244.063-.372a1.037,1.037,0,0,1,.053-.208.306.306,0,0,1,.2-.185.24.24,0,0,1,.264.121.531.531,0,0,1,.066.224,1.872,1.872,0,0,1,0,.389,1.939,1.939,0,0,1-.178.628c-.165.336-.349.484-.362.47s.124-.191.251-.518a2.117,2.117,0,0,0,.132-.594,1.864,1.864,0,0,0-.008-.357c-.009-.118-.07-.222-.121-.2-.073.016-.107.129-.13.26l-.072.364a3.833,3.833,0,0,0-.066.616C182.287,441.63,182.365,441.841,182.338,441.85Z" transform="translate(-182.165 -439.864)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15594" data-name="Group 15594" transform="translate(30.026 41.926)">
                    <g id="Group_15593" data-name="Group 15593">
                      <g id="Group_15592" data-name="Group 15592">
                        <path id="Path_20289" data-name="Path 20289" d="M182.678,443.585c0,.009-.028.023-.092.041l-.05.015.023-.054a1.955,1.955,0,0,1,.384-.55,2.454,2.454,0,0,1,.4-.338,2.684,2.684,0,0,1,.257-.15.506.506,0,0,1,.17-.057.26.26,0,0,1,.212.068.226.226,0,0,1,.022.278.78.78,0,0,1-.133.159,2.13,2.13,0,0,1-.28.231,2.055,2.055,0,0,1-.547.27.992.992,0,0,1-.551.065c0-.028.206-.052.51-.179a2.311,2.311,0,0,0,.5-.284,2.194,2.194,0,0,0,.253-.221c.091-.082.146-.184.11-.2-.062-.076-.29.073-.431.154a2.81,2.81,0,0,0-.4.3,3.925,3.925,0,0,0-.435.479l-.027-.039C182.644,443.572,182.676,443.576,182.678,443.585Z" transform="translate(-182.498 -442.49)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15598" data-name="Group 15598" transform="translate(24.8 43.087)">
                  <g id="Group_15597" data-name="Group 15597">
                    <g id="Group_15596" data-name="Group 15596">
                      <path id="Path_20290" data-name="Path 20290" d="M148.546,275.713l2.877.464,1.87,2.589-.544,1.972-.342.11.069.739a.819.819,0,0,1-.429.8h0l-1.49-2.582.615,2.619a1.3,1.3,0,0,1-1-.171c-.632-.321-1.308-3.241-1.308-3.241l-.993-.62.976,3.245a1.092,1.092,0,0,1-.848.305c-.551-.03-1.67-2.975-1.67-2.975l-14.979,2.1-.031-1.936,3.633-6.021Z" transform="translate(-131.315 -273.105)" fill="#ffceaf" />
                    </g>
                  </g>
                </g>
                <g id="Group_15821" data-name="Group 15821" transform="translate(4.909)">
                  <g id="Group_15600" data-name="Group 15600" transform="translate(0 3.061)">
                    <g id="Group_15599" data-name="Group 15599">
                      <path id="Path_20291" data-name="Path 20291" d="M75.432,169.805a5.156,5.156,0,0,1-3.167-3.754,20.055,20.055,0,0,0-.342-2.139c-.309-.99-1.075-1.846-1.113-2.882A16.641,16.641,0,0,1,71.152,159a18.4,18.4,0,0,0-.126-1.989,4.3,4.3,0,0,1,2.638-3.979l4.142-1.682,6.385,2.6s3.632,3.525,2.587,10.779Z" transform="translate(-70.809 -151.347)" fill="#f46a4e" />
                    </g>
                  </g>
                  <g id="Group_15755" data-name="Group 15755" transform="translate(1.013 5.905)">
                    <g id="Group_15717" data-name="Group 15717" transform="translate(1.47)">
                      <g id="Group_15602" data-name="Group 15602" transform="translate(12.605 10.749)">
                        <g id="Group_15601" data-name="Group 15601">
                          <path id="Path_20292" data-name="Path 20292" d="M116.891,193.122a1.227,1.227,0,0,1,.458-.364h-.037a.7.7,0,0,1,.1-.027.487.487,0,0,1,.385.013h0a.906.906,0,0,1,.531.385,1.07,1.07,0,0,1-.027,1.11.818.818,0,0,1-1.52-.146A1.015,1.015,0,0,1,116.891,193.122Z" transform="translate(-116.706 -192.699)" fill="#455a64" />
                        </g>
                      </g>
                      <g id="Group_15604" data-name="Group 15604">
                        <g id="Group_15603" data-name="Group 15603">
                          <path id="Path_20293" data-name="Path 20293" d="M91.079,164.539c-.423-2.315-2.308-4.994-4.6-4.473l-7.04,2.694a1.378,1.378,0,0,0-1.06,1.532l2.087,15.521a4.3,4.3,0,0,0,3.965,3.712h0A4.3,4.3,0,0,0,89,178.92c-.08-1.071-.138-1.876-.137-1.871s2.922-.848,3.079-4.809A41.85,41.85,0,0,0,91.079,164.539Z" transform="translate(-78.363 -160)" fill="#ffceaf" />
                        </g>
                      </g>
                      <g id="Group_15616" data-name="Group 15616" transform="translate(10.986 7.562)">
                        <g id="Group_15615" data-name="Group 15615">
                          <g id="Group_15614" data-name="Group 15614">
                            <g id="Group_15613" data-name="Group 15613">
                              <g id="Group_15612" data-name="Group 15612">
                                <g id="Group_15611" data-name="Group 15611">
                                  <g id="Group_15610" data-name="Group 15610">
                                    <g id="Group_15609" data-name="Group 15609">
                                      <g id="Group_15608" data-name="Group 15608">
                                        <g id="Group_15607" data-name="Group 15607">
                                          <g id="Group_15606" data-name="Group 15606">
                                            <g id="Group_15605" data-name="Group 15605">
                                              <path id="Path_20294" data-name="Path 20294" d="M112.776,183.4a.5.5,0,0,1-.421.56.48.48,0,0,1-.567-.389.5.5,0,0,1,.42-.56A.481.481,0,0,1,112.776,183.4Z" transform="translate(-111.782 -183.004)" fill="#263238" />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15629" data-name="Group 15629" transform="translate(10.249 5.851)">
                        <g id="Group_15628" data-name="Group 15628">
                          <g id="Group_15627" data-name="Group 15627">
                            <g id="Group_15626" data-name="Group 15626">
                              <g id="Group_15625" data-name="Group 15625">
                                <g id="Group_15624" data-name="Group 15624">
                                  <g id="Group_15623" data-name="Group 15623">
                                    <g id="Group_15622" data-name="Group 15622">
                                      <g id="Group_15621" data-name="Group 15621">
                                        <g id="Group_15620" data-name="Group 15620">
                                          <g id="Group_15619" data-name="Group 15619">
                                            <g id="Group_15618" data-name="Group 15618">
                                              <g id="Group_15617" data-name="Group 15617">
                                                <path id="Path_20295" data-name="Path 20295" d="M111.513,178.218c-.054.072-.465-.162-1-.1s-.9.38-.964.321c-.032-.026.017-.151.174-.3a1.379,1.379,0,0,1,.762-.337,1.322,1.322,0,0,1,.807.159C111.47,178.074,111.54,178.185,111.513,178.218Z" transform="translate(-109.539 -177.799)" fill="#263238" />
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15641" data-name="Group 15641" transform="translate(6.225 8.045)">
                        <g id="Group_15640" data-name="Group 15640">
                          <g id="Group_15639" data-name="Group 15639">
                            <g id="Group_15638" data-name="Group 15638">
                              <g id="Group_15637" data-name="Group 15637">
                                <g id="Group_15636" data-name="Group 15636">
                                  <g id="Group_15635" data-name="Group 15635">
                                    <g id="Group_15634" data-name="Group 15634">
                                      <g id="Group_15633" data-name="Group 15633">
                                        <g id="Group_15632" data-name="Group 15632">
                                          <g id="Group_15631" data-name="Group 15631">
                                            <g id="Group_15630" data-name="Group 15630">
                                              <path id="Path_20296" data-name="Path 20296" d="M98.292,184.868a.5.5,0,0,1-.421.56.48.48,0,0,1-.567-.389.5.5,0,0,1,.421-.561A.48.48,0,0,1,98.292,184.868Z" transform="translate(-97.298 -184.471)" fill="#263238" />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15654" data-name="Group 15654" transform="translate(4.986 6.576)">
                        <g id="Group_15653" data-name="Group 15653">
                          <g id="Group_15652" data-name="Group 15652">
                            <g id="Group_15651" data-name="Group 15651">
                              <g id="Group_15650" data-name="Group 15650">
                                <g id="Group_15649" data-name="Group 15649">
                                  <g id="Group_15648" data-name="Group 15648">
                                    <g id="Group_15647" data-name="Group 15647">
                                      <g id="Group_15646" data-name="Group 15646">
                                        <g id="Group_15645" data-name="Group 15645">
                                          <g id="Group_15644" data-name="Group 15644">
                                            <g id="Group_15643" data-name="Group 15643">
                                              <g id="Group_15642" data-name="Group 15642">
                                                <path id="Path_20297" data-name="Path 20297" d="M95.5,180.423c-.054.072-.466-.162-1-.1s-.9.38-.964.321c-.032-.026.016-.151.174-.3a1.375,1.375,0,0,1,.762-.337,1.324,1.324,0,0,1,.807.159C95.461,180.279,95.531,180.39,95.5,180.423Z" transform="translate(-93.53 -180.004)" fill="#263238" />
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15666" data-name="Group 15666" transform="translate(8.6 6.301)">
                        <g id="Group_15665" data-name="Group 15665">
                          <g id="Group_15664" data-name="Group 15664">
                            <g id="Group_15663" data-name="Group 15663">
                              <g id="Group_15662" data-name="Group 15662">
                                <g id="Group_15661" data-name="Group 15661">
                                  <g id="Group_15660" data-name="Group 15660">
                                    <g id="Group_15659" data-name="Group 15659">
                                      <g id="Group_15658" data-name="Group 15658">
                                        <g id="Group_15657" data-name="Group 15657">
                                          <g id="Group_15656" data-name="Group 15656">
                                            <g id="Group_15655" data-name="Group 15655">
                                              <path id="Path_20298" data-name="Path 20298" d="M105.3,183.609a3.581,3.581,0,0,1,.853-.26c.135-.031.262-.073.274-.169a.7.7,0,0,0-.139-.4l-.529-1a18.059,18.059,0,0,1-1.233-2.621,18.09,18.09,0,0,1,1.441,2.516l.512,1a.8.8,0,0,1,.135.529.346.346,0,0,1-.2.227.947.947,0,0,1-.229.06A3.518,3.518,0,0,1,105.3,183.609Z" transform="translate(-104.524 -179.167)" fill="#263238" />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15677" data-name="Group 15677" transform="translate(5.13 16.277)">
                        <g id="Group_15676" data-name="Group 15676">
                          <g id="Group_15675" data-name="Group 15675">
                            <g id="Group_15674" data-name="Group 15674">
                              <g id="Group_15673" data-name="Group 15673">
                                <g id="Group_15672" data-name="Group 15672">
                                  <g id="Group_15671" data-name="Group 15671">
                                    <g id="Group_15670" data-name="Group 15670">
                                      <g id="Group_15669" data-name="Group 15669">
                                        <g id="Group_15668" data-name="Group 15668">
                                          <g id="Group_15667" data-name="Group 15667">
                                            <path id="Path_20299" data-name="Path 20299" d="M99.341,210.285a9.958,9.958,0,0,1-5.372-.772s1.58,2.521,5.428,1.7Z" transform="translate(-93.969 -209.513)" fill="#e5b38e" />
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15688" data-name="Group 15688" transform="translate(7.563 11.568)">
                        <g id="Group_15687" data-name="Group 15687">
                          <g id="Group_15686" data-name="Group 15686">
                            <g id="Group_15685" data-name="Group 15685">
                              <g id="Group_15684" data-name="Group 15684">
                                <g id="Group_15683" data-name="Group 15683">
                                  <g id="Group_15682" data-name="Group 15682">
                                    <g id="Group_15681" data-name="Group 15681">
                                      <g id="Group_15680" data-name="Group 15680">
                                        <g id="Group_15679" data-name="Group 15679">
                                          <g id="Group_15678" data-name="Group 15678">
                                            <path id="Path_20300" data-name="Path 20300" d="M103.258,195.649a1.33,1.33,0,0,0-1.155-.448.867.867,0,0,0-.661.468.794.794,0,0,0,1.024,1.076,1.976,1.976,0,0,0,.732-.582.619.619,0,0,0,.146-.221.276.276,0,0,0-.053-.27" transform="translate(-101.37 -195.188)" fill="#e5b38e" />
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15700" data-name="Group 15700" transform="translate(7.785 11.301)">
                        <g id="Group_15699" data-name="Group 15699">
                          <g id="Group_15698" data-name="Group 15698">
                            <g id="Group_15697" data-name="Group 15697">
                              <g id="Group_15696" data-name="Group 15696">
                                <g id="Group_15695" data-name="Group 15695">
                                  <g id="Group_15694" data-name="Group 15694">
                                    <g id="Group_15693" data-name="Group 15693">
                                      <g id="Group_15692" data-name="Group 15692">
                                        <g id="Group_15691" data-name="Group 15691">
                                          <g id="Group_15690" data-name="Group 15690">
                                            <g id="Group_15689" data-name="Group 15689">
                                              <path id="Path_20301" data-name="Path 20301" d="M102.1,194.377c.087-.015.157.567.7.921s1.16.217,1.174.3c.012.036-.125.13-.386.168a1.458,1.458,0,0,1-.976-.216,1.271,1.271,0,0,1-.553-.777C102.015,194.531,102.063,194.379,102.1,194.377Z" transform="translate(-102.044 -194.377)" fill="#263238" />
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15708" data-name="Group 15708" transform="translate(4.515 4.462)">
                        <g id="Group_15707" data-name="Group 15707">
                          <g id="Group_15706" data-name="Group 15706">
                            <g id="Group_15705" data-name="Group 15705">
                              <g id="Group_15704" data-name="Group 15704">
                                <g id="Group_15703" data-name="Group 15703">
                                  <g id="Group_15702" data-name="Group 15702">
                                    <g id="Group_15701" data-name="Group 15701">
                                      <path id="Path_20302" data-name="Path 20302" d="M94.518,173.868c-.036.152-.58.147-1.2.3s-1.109.382-1.208.261c-.045-.058.028-.206.216-.371a2.15,2.15,0,0,1,1.835-.425C94.4,173.7,94.532,173.8,94.518,173.868Z" transform="translate(-92.096 -173.573)" fill="#263238" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15716" data-name="Group 15716" transform="translate(9.976 3.991)">
                        <g id="Group_15715" data-name="Group 15715">
                          <g id="Group_15714" data-name="Group 15714">
                            <g id="Group_15713" data-name="Group 15713">
                              <g id="Group_15712" data-name="Group 15712">
                                <g id="Group_15711" data-name="Group 15711">
                                  <g id="Group_15710" data-name="Group 15710">
                                    <g id="Group_15709" data-name="Group 15709">
                                      <path id="Path_20303" data-name="Path 20303" d="M110.548,172.594c-.08.133-.465.05-.91.1-.447.031-.811.179-.913.062-.045-.058,0-.186.15-.322a1.326,1.326,0,0,1,1.469-.128C110.517,172.41,110.583,172.53,110.548,172.594Z" transform="translate(-108.709 -172.139)" fill="#263238" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15719" data-name="Group 15719" transform="translate(0 0.964)">
                      <g id="Group_15718" data-name="Group 15718">
                        <path id="Path_20304" data-name="Path 20304" d="M80.464,162.932a13.875,13.875,0,0,0-5.156,1.326,2.526,2.526,0,0,0-1.223.983,2.478,2.478,0,0,0-.173,1.373,13.785,13.785,0,0,0,1.5,4.517l.766,1.118c1-.31,1.7-2.975,1.539-4.186A2.881,2.881,0,0,0,79.21,165.4,3.188,3.188,0,0,0,80.464,162.932Z" transform="translate(-73.89 -162.932)" fill="#263238" />
                      </g>
                    </g>
                    <g id="Group_15749" data-name="Group 15749" transform="translate(0.972 8.868)">
                      <g id="Group_15733" data-name="Group 15733">
                        <g id="Group_15732" data-name="Group 15732">
                          <g id="Group_15731" data-name="Group 15731">
                            <g id="Group_15730" data-name="Group 15730">
                              <g id="Group_15729" data-name="Group 15729">
                                <g id="Group_15728" data-name="Group 15728">
                                  <g id="Group_15727" data-name="Group 15727">
                                    <g id="Group_15726" data-name="Group 15726">
                                      <g id="Group_15725" data-name="Group 15725">
                                        <g id="Group_15724" data-name="Group 15724">
                                          <g id="Group_15723" data-name="Group 15723">
                                            <g id="Group_15722" data-name="Group 15722">
                                              <g id="Group_15721" data-name="Group 15721">
                                                <g id="Group_15720" data-name="Group 15720">
                                                  <path id="Path_20305" data-name="Path 20305" d="M79.238,187.706c-.117-.832-1.155-.918-1.842-.435a1.577,1.577,0,0,0-.523,1.638A1.787,1.787,0,0,0,79.48,190.4C79.477,190.358,79.375,188.68,79.238,187.706Z" transform="translate(-76.846 -186.976)" fill="#fdd9be" />
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15748" data-name="Group 15748" transform="translate(0.618 0.818)">
                        <g id="Group_15747" data-name="Group 15747">
                          <g id="Group_15746" data-name="Group 15746">
                            <g id="Group_15745" data-name="Group 15745">
                              <g id="Group_15744" data-name="Group 15744">
                                <g id="Group_15743" data-name="Group 15743">
                                  <g id="Group_15742" data-name="Group 15742">
                                    <g id="Group_15741" data-name="Group 15741">
                                      <g id="Group_15740" data-name="Group 15740">
                                        <g id="Group_15739" data-name="Group 15739">
                                          <g id="Group_15738" data-name="Group 15738">
                                            <g id="Group_15737" data-name="Group 15737">
                                              <g id="Group_15736" data-name="Group 15736">
                                                <g id="Group_15735" data-name="Group 15735">
                                                  <g id="Group_15734" data-name="Group 15734">
                                                    <path id="Path_20306" data-name="Path 20306" d="M79.9,191.272c-.011-.006-.037.034-.1.075a.414.414,0,0,1-.306.047,1.026,1.026,0,0,1-.59-.85,1.368,1.368,0,0,1,.038-.6.478.478,0,0,1,.267-.356.211.211,0,0,1,.257.081c.04.062.032.111.045.113s.045-.046.013-.141a.265.265,0,0,0-.112-.136.312.312,0,0,0-.235-.03.582.582,0,0,0-.381.421,1.4,1.4,0,0,0-.056.676,1.075,1.075,0,0,0,.732.939.444.444,0,0,0,.367-.112C79.907,191.33,79.913,191.275,79.9,191.272Z" transform="translate(-78.724 -189.463)" fill="#6f4c47" />
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15754" data-name="Group 15754" transform="translate(1.299 11.698)">
                      <g id="Group_15753" data-name="Group 15753">
                        <g id="Group_15752" data-name="Group 15752">
                          <g id="Group_15751" data-name="Group 15751">
                            <g id="Group_15750" data-name="Group 15750">
                              <path id="Path_20307" data-name="Path 20307" d="M78.026,196.008a1.226,1.226,0,0,1,.458-.364h-.037a.7.7,0,0,1,.1-.027.486.486,0,0,1,.385.013h0a.9.9,0,0,1,.531.385,1.07,1.07,0,0,1-.027,1.11.818.818,0,0,1-1.521-.146A1.015,1.015,0,0,1,78.026,196.008Z" transform="translate(-77.841 -195.585)" fill="#455a64" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15757" data-name="Group 15757" transform="translate(0.403)">
                    <g id="Group_15756" data-name="Group 15756">
                      <path id="Path_20308" data-name="Path 20308" d="M72.324,149.346a3.872,3.872,0,0,1,2.847-2.046,6.667,6.667,0,0,1,1.058-.118,3.883,3.883,0,0,1-.148-1.434,4.141,4.141,0,0,1,2.318-3.278,5.154,5.154,0,0,1,3.9-.1,5.025,5.025,0,0,1,2.908,2.4,3.572,3.572,0,0,1-.31,3.8,6.819,6.819,0,0,1-3.422,1.564,4.764,4.764,0,0,1-3.312-.476c-2.975,2.443-3.722,6.483-4.217,10.14-1.292-2.275-1.573-4.967-1.827-7.572A5.752,5.752,0,0,1,72.324,149.346Z" transform="translate(-72.033 -142.037)" fill="#f46a4e" />
                    </g>
                  </g>
                  <g id="Group_15760" data-name="Group 15760" transform="translate(4.206 6.65)">
                    <g id="Group_15759" data-name="Group 15759">
                      <g id="Group_15758" data-name="Group 15758">
                        <path id="Path_20309" data-name="Path 20309" d="M83.607,163.193c-.035-.032.13-.265.368-.52s.459-.436.493-.4-.13.265-.368.52S83.641,163.225,83.607,163.193Z" transform="translate(-83.602 -162.265)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15763" data-name="Group 15763" transform="translate(11.086 0.778)">
                    <g id="Group_15762" data-name="Group 15762">
                      <g id="Group_15761" data-name="Group 15761">
                        <path id="Path_20310" data-name="Path 20310" d="M104.531,150c-.021-.021.232-.258.529-.72a4.312,4.312,0,0,0,.341-4.079c-.216-.5-.427-.78-.4-.8.009-.007.07.055.166.179a3.443,3.443,0,0,1,.346.568,4.1,4.1,0,0,1-.35,4.2,3.424,3.424,0,0,1-.436.5C104.61,149.958,104.539,150.008,104.531,150Z" transform="translate(-104.53 -144.404)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15766" data-name="Group 15766" transform="translate(9.596 0.926)">
                    <g id="Group_15765" data-name="Group 15765">
                      <g id="Group_15764" data-name="Group 15764">
                        <path id="Path_20311" data-name="Path 20311" d="M100,148.261a2.282,2.282,0,0,1,.4-.454,9.24,9.24,0,0,0,.93-1.089,3.814,3.814,0,0,0,.591-1.279c.084-.354.077-.585.105-.585a1.184,1.184,0,0,1,.013.608,3.288,3.288,0,0,1-.569,1.354,6.246,6.246,0,0,1-.987,1.078A2,2,0,0,1,100,148.261Z" transform="translate(-99.998 -144.853)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15769" data-name="Group 15769" transform="translate(4.046 3.991)" opacity="0.3">
                    <g id="Group_15768" data-name="Group 15768">
                      <g id="Group_15767" data-name="Group 15767">
                        <path id="Path_20312" data-name="Path 20312" d="M83.506,154.178a4.356,4.356,0,0,0,2.073,3.645l-.041.067a2.392,2.392,0,0,1-2.032-3.712Z" transform="translate(-83.117 -154.178)" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15772" data-name="Group 15772" transform="translate(1.593 9.184)">
                    <g id="Group_15771" data-name="Group 15771">
                      <g id="Group_15770" data-name="Group 15770">
                        <path id="Path_20313" data-name="Path 20313" d="M75.655,169.979a4.05,4.05,0,0,1,.793.389,4.092,4.092,0,0,1,.781.412,2.54,2.54,0,0,1-1.575-.8Z" transform="translate(-75.653 -169.975)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15775" data-name="Group 15775" transform="translate(0.137 11.608)">
                    <g id="Group_15774" data-name="Group 15774">
                      <g id="Group_15773" data-name="Group 15773">
                        <path id="Path_20314" data-name="Path 20314" d="M71.225,177.359a7.112,7.112,0,0,1,1.058.1,7.1,7.1,0,0,1,1.059.092,3.3,3.3,0,0,1-2.117-.194Z" transform="translate(-71.225 -177.346)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15778" data-name="Group 15778" transform="translate(2.696 4.692)">
                    <g id="Group_15777" data-name="Group 15777">
                      <g id="Group_15776" data-name="Group 15776">
                        <path id="Path_20315" data-name="Path 20315" d="M79.387,156.309c.049.015-.123.651-.187,1.455s0,1.459-.056,1.466a4.64,4.64,0,0,1,.243-2.92Z" transform="translate(-79.01 -156.309)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15781" data-name="Group 15781" transform="translate(3.951 8.815)">
                    <g id="Group_15780" data-name="Group 15780">
                      <g id="Group_15779" data-name="Group 15779">
                        <path id="Path_20316" data-name="Path 20316" d="M82.828,168.9c.009-.049.3-.029.662-.037s.653-.04.663.009-.279.155-.66.163S82.818,168.949,82.828,168.9Z" transform="translate(-82.827 -168.85)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15784" data-name="Group 15784" transform="translate(1.729 13.37)">
                    <g id="Group_15783" data-name="Group 15783">
                      <g id="Group_15782" data-name="Group 15782">
                        <path id="Path_20317" data-name="Path 20317" d="M76.072,182.708a3.123,3.123,0,0,1,1.061,1.566,18.254,18.254,0,0,1-1.061-1.566Z" transform="translate(-76.069 -182.706)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15787" data-name="Group 15787" transform="translate(7.795 0.32)">
                    <g id="Group_15786" data-name="Group 15786">
                      <g id="Group_15785" data-name="Group 15785">
                        <path id="Path_20318" data-name="Path 20318" d="M94.522,149.357a6.1,6.1,0,0,1,.321-.939l.836-2.237.809-2.247a6.089,6.089,0,0,1,.362-.923,5.366,5.366,0,0,1-.247.961c-.177.586-.442,1.39-.764,2.268s-.64,1.662-.884,2.224A5.371,5.371,0,0,1,94.522,149.357Z" transform="translate(-94.519 -143.011)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15790" data-name="Group 15790" transform="translate(5.742 0.302)">
                    <g id="Group_15789" data-name="Group 15789">
                      <g id="Group_15788" data-name="Group 15788">
                        <path id="Path_20319" data-name="Path 20319" d="M88.275,144.77a2.45,2.45,0,0,1,.575-.407,11.613,11.613,0,0,1,3.134-1.288,2.469,2.469,0,0,1,.695-.115c.012.051-1.03.3-2.244.8S88.3,144.814,88.275,144.77Z" transform="translate(-88.275 -142.954)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15793" data-name="Group 15793" transform="translate(12.499 3.515)">
                    <g id="Group_15792" data-name="Group 15792">
                      <g id="Group_15791" data-name="Group 15791">
                        <path id="Path_20320" data-name="Path 20320" d="M108.832,152.731a3.085,3.085,0,0,1,.983,2.523c-.052,0-.083-.616-.359-1.313S108.792,152.764,108.832,152.731Z" transform="translate(-108.829 -152.729)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15796" data-name="Group 15796" transform="translate(8.031 7.294)">
                    <g id="Group_15795" data-name="Group 15795">
                      <g id="Group_15794" data-name="Group 15794">
                        <path id="Path_20321" data-name="Path 20321" d="M95.238,165.045a2.774,2.774,0,0,0,1.742-.819c.043.014-.183.47-.725.72A1.233,1.233,0,0,1,95.238,165.045Z" transform="translate(-95.238 -164.225)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15799" data-name="Group 15799" transform="translate(4.723 4.098)">
                    <g id="Group_15798" data-name="Group 15798">
                      <g id="Group_15797" data-name="Group 15797">
                        <path id="Path_20322" data-name="Path 20322" d="M85.191,156.072a1.411,1.411,0,0,1,.262-.9c.27-.46.639-.7.664-.664s-.266.322-.516.751S85.24,156.082,85.191,156.072Z" transform="translate(-85.175 -154.503)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15802" data-name="Group 15802" transform="translate(15.235 10.012)">
                    <g id="Group_15801" data-name="Group 15801">
                      <g id="Group_15800" data-name="Group 15800">
                        <path id="Path_20323" data-name="Path 20323" d="M117.159,173.114c-.028-.04.078-.161.179-.323s.17-.307.217-.3.05.2-.073.39S117.184,173.152,117.159,173.114Z" transform="translate(-117.154 -172.493)" fill="#fff" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15805" data-name="Group 15805" transform="translate(1.163 6.928)">
                    <g id="Group_15804" data-name="Group 15804">
                      <g id="Group_15803" data-name="Group 15803">
                        <path id="Path_20324" data-name="Path 20324" d="M78.581,163.111c.022.02-.355.435-.9,1.158a17.662,17.662,0,0,0-3,6.322c-.219.875-.3,1.43-.332,1.426a1.731,1.731,0,0,1,.03-.394c.028-.252.089-.615.184-1.06A15.613,15.613,0,0,1,77.59,164.2c.284-.355.527-.632.705-.812A1.718,1.718,0,0,1,78.581,163.111Z" transform="translate(-74.347 -163.111)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15808" data-name="Group 15808" transform="translate(0.354 6.04)">
                    <g id="Group_15807" data-name="Group 15807">
                      <g id="Group_15806" data-name="Group 15806">
                        <path id="Path_20325" data-name="Path 20325" d="M71.886,165.307a4.241,4.241,0,0,1,.47-.878,12.744,12.744,0,0,1,3.274-3.493,4.226,4.226,0,0,1,.846-.526,8.786,8.786,0,0,1-.772.622,16.18,16.18,0,0,0-3.246,3.463A8.747,8.747,0,0,1,71.886,165.307Z" transform="translate(-71.885 -160.41)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15811" data-name="Group 15811" transform="translate(5.572 0.775)">
                    <g id="Group_15810" data-name="Group 15810">
                      <g id="Group_15809" data-name="Group 15809">
                        <path id="Path_20326" data-name="Path 20326" d="M88.534,144.394c.015.01-.1.162-.251.468a3.982,3.982,0,0,0-.377,1.375,4.146,4.146,0,0,0,.348,2.064,4.29,4.29,0,0,0,1.722,1.876,4.79,4.79,0,0,0,2.47.677,5.049,5.049,0,0,0,2.065-.416,3.372,3.372,0,0,0,1.148-.837c.223-.256.307-.429.325-.418s-.014.046-.058.126a2.081,2.081,0,0,1-.216.334,3.23,3.23,0,0,1-1.148.9,5.02,5.02,0,0,1-2.117.464,4.871,4.871,0,0,1-2.558-.687,4.386,4.386,0,0,1-1.778-1.959,4.177,4.177,0,0,1-.325-2.141,3.753,3.753,0,0,1,.439-1.394,2.638,2.638,0,0,1,.219-.332C88.5,144.427,88.529,144.391,88.534,144.394Z" transform="translate(-87.76 -144.394)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15814" data-name="Group 15814" transform="translate(4.436 3.192)">
                    <g id="Group_15813" data-name="Group 15813">
                      <g id="Group_15812" data-name="Group 15812">
                        <path id="Path_20327" data-name="Path 20327" d="M84.446,151.745c.029,0-.028.355-.019.92a4.627,4.627,0,0,0,.514,2.108,3.377,3.377,0,0,0,1.565,1.461,5.877,5.877,0,0,0,.873.259.619.619,0,0,1-.251.009,2.4,2.4,0,0,1-.668-.156,3.281,3.281,0,0,1-1.669-1.491,4.326,4.326,0,0,1-.486-2.191,4.463,4.463,0,0,1,.072-.678A.668.668,0,0,1,84.446,151.745Z" transform="translate(-84.302 -151.745)" fill="#263238" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15817" data-name="Group 15817" transform="translate(1.329 9.268)" opacity="0.3">
                    <g id="Group_15816" data-name="Group 15816">
                      <g id="Group_15815" data-name="Group 15815">
                        <path id="Path_20328" data-name="Path 20328" d="M76.38,171.515a25.024,25.024,0,0,0-1.348,3.8,2.328,2.328,0,0,0-.127,1.325c.025.085.095.184.178.154.054-.019.074-.083.088-.137a56.87,56.87,0,0,1,2.042-6.43Z" transform="translate(-74.851 -170.229)" />
                      </g>
                    </g>
                  </g>
                  <g id="Group_15820" data-name="Group 15820" transform="translate(11.176 1.232)" opacity="0.3">
                    <g id="Group_15819" data-name="Group 15819">
                      <g id="Group_15818" data-name="Group 15818">
                        <path id="Path_20329" data-name="Path 20329" d="M105.554,145.783a4.759,4.759,0,0,1-.748,5.1,1.771,1.771,0,0,0,1.288-1.143A4.185,4.185,0,0,0,105.554,145.783Z" transform="translate(-104.806 -145.783)" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15900" data-name="Group 15900" transform="translate(0 25.394)">
                  <g id="Group_15841" data-name="Group 15841" transform="translate(3.014)">
                    <g id="Group_15824" data-name="Group 15824">
                      <g id="Group_15823" data-name="Group 15823">
                        <g id="Group_15822" data-name="Group 15822">
                          <path id="Path_20330" data-name="Path 20330" d="M103.562,250.7q-9.13-.22-17.61.04l.06-.038,1.963-18.473L80.514,219.7l-.446-.421a7.455,7.455,0,0,1-4.7.792l-4.337-.741h0a76.228,76.228,0,0,0-5.56,5.521c0,.17,4.819,23.556,4.819,23.556l2.867,2.815-8.113,5.705s.166,5.632,3.973,7.169,20.731.372,22.7.128c0,0,7.4-2.874,8.42-3.753S103.855,252.614,103.562,250.7Z" transform="translate(-65.045 -219.284)" fill="#9f5c6e" />
                        </g>
                      </g>
                    </g>
                    <g id="Group_15828" data-name="Group 15828" transform="translate(18.257 34.016)">
                      <g id="Group_15827" data-name="Group 15827">
                        <g id="Group_15826" data-name="Group 15826">
                          <g id="Group_15825" data-name="Group 15825">
                            <path id="Path_20331" data-name="Path 20331" d="M120.583,322.761a.749.749,0,0,1,.176.017l.5.078c.433.071,1.057.186,1.824.343,1.537.31,3.647.8,5.965,1.385l5.927,1.535,1.795.47.487.132a.089.089,0,1,1-.007.031l-.494-.1c-.428-.093-1.046-.237-1.807-.422-1.524-.367-3.621-.9-5.939-1.49s-4.421-1.092-5.95-1.429c-.764-.171-1.384-.3-1.813-.391l-.493-.107A.768.768,0,0,1,120.583,322.761Z" transform="translate(-120.583 -322.759)" fill="#455a64" />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15832" data-name="Group 15832" transform="translate(16.616 31.284)">
                      <g id="Group_15831" data-name="Group 15831">
                        <g id="Group_15830" data-name="Group 15830">
                          <g id="Group_15829" data-name="Group 15829">
                            <path id="Path_20332" data-name="Path 20332" d="M115.589,314.475a12.985,12.985,0,0,1,2.834.2,12.986,12.986,0,0,1-2.834-.2Z" transform="translate(-115.589 -314.448)" fill="#455a64" />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15836" data-name="Group 15836" transform="translate(16.53 27.943)">
                      <g id="Group_15835" data-name="Group 15835">
                        <g id="Group_15834" data-name="Group 15834">
                          <g id="Group_15833" data-name="Group 15833">
                            <path id="Path_20333" data-name="Path 20333" d="M115.329,304.285c.038-.028.509.6,1.215,1.249s1.361,1.079,1.336,1.119a6.308,6.308,0,0,1-2.551-2.368Z" transform="translate(-115.327 -304.284)" fill="#455a64" />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15840" data-name="Group 15840" transform="translate(16.123 12.579)">
                      <g id="Group_15839" data-name="Group 15839">
                        <g id="Group_15838" data-name="Group 15838">
                          <g id="Group_15837" data-name="Group 15837">
                            <path id="Path_20334" data-name="Path 20334" d="M114.09,263.216c-.019-.02.241-.258.589-.7a6.908,6.908,0,0,0,1.477-4.051c.017-.562-.028-.912,0-.915a.764.764,0,0,1,.057.242,4.408,4.408,0,0,1,.054.674,6.25,6.25,0,0,1-1.5,4.12,4.337,4.337,0,0,1-.476.481C114.168,263.171,114.1,263.224,114.09,263.216Z" transform="translate(-114.089 -257.55)" fill="#455a64" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15849" data-name="Group 15849" transform="translate(18.036)">
                    <g id="Group_15844" data-name="Group 15844">
                      <g id="Group_15843" data-name="Group 15843">
                        <g id="Group_15842" data-name="Group 15842">
                          <path id="Path_20335" data-name="Path 20335" d="M113.938,220.085h0c2.113,1.307,4.2,4.668,4.719,8.24l1.171,5.537a1.184,1.184,0,0,1,1.431.2,2.176,2.176,0,0,1,.466,1.671l2.428,1.7-3.883,2.825-2.655,3.267s2.278,6.693,2.655,7.35,1.128,1.795,1.128,1.795L117.922,252a5.773,5.773,0,0,1-2.255-4.51c.094-2.819.371-13.625,0-15.034s-4.922-13.168-4.922-13.168Z" transform="translate(-110.742 -219.284)" fill="#5c4a72" />
                        </g>
                      </g>
                    </g>
                    <g id="Group_15848" data-name="Group 15848" transform="translate(7.198 8.043)">
                      <g id="Group_15847" data-name="Group 15847">
                        <g id="Group_15846" data-name="Group 15846">
                          <g id="Group_15845" data-name="Group 15845">
                            <path id="Path_20336" data-name="Path 20336" d="M132.719,259.885a.639.639,0,0,1-.024-.163c-.01-.125-.023-.281-.038-.47-.02-.409-.029-1-.008-1.735.04-1.464.2-3.479.3-5.706a52.161,52.161,0,0,0-.028-5.7c-.058-.728-.1-1.317-.155-1.723-.019-.189-.034-.344-.046-.468a.646.646,0,0,1-.006-.165.658.658,0,0,1,.036.161c.02.124.045.277.075.465.07.4.133.993.205,1.722a44.95,44.95,0,0,1,.074,5.719c-.1,2.231-.282,4.244-.35,5.7-.035.729-.043,1.32-.041,1.729,0,.19.006.345.009.47A.686.686,0,0,1,132.719,259.885Z" transform="translate(-132.637 -243.751)" fill="#263238" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15899" data-name="Group 15899" transform="translate(0 0.051)">
                    <g id="Group_15881" data-name="Group 15881">
                      <g id="Group_15852" data-name="Group 15852">
                        <g id="Group_15851" data-name="Group 15851">
                          <g id="Group_15850" data-name="Group 15850">
                            <path id="Path_20337" data-name="Path 20337" d="M73.666,240.752l-1.643-6.275-7.145-15.038-6.09,2.942a2.84,2.84,0,0,0-.464.224h0a4.423,4.423,0,0,0-1.454,1.558,7.3,7.3,0,0,0-.9,4.887l2.345,14.874a39.013,39.013,0,0,0,2.295,4.923l-3.548,10.709s9.065,4.532,11.993,4.518c2.476-.012,4.639-.027,5.048-4.853S73.666,240.752,73.666,240.752Z" transform="translate(-55.876 -219.439)" fill="#5c4a72" />
                          </g>
                        </g>
                      </g>
                      <g id="Group_15856" data-name="Group 15856" transform="translate(10.225 21.235)">
                        <g id="Group_15855" data-name="Group 15855">
                          <g id="Group_15854" data-name="Group 15854">
                            <g id="Group_15853" data-name="Group 15853">
                              <path id="Path_20338" data-name="Path 20338" d="M86.981,286.926c-.02-.01.089-.3.232-.779a7.7,7.7,0,0,1,.3-.837,2.294,2.294,0,0,1,.643-.9,1.794,1.794,0,0,1,1.043-.376,2.024,2.024,0,0,1,.888.164,1.676,1.676,0,0,1,.507.333c.1.1.144.168.138.174a3.13,3.13,0,0,0-.685-.4,2.04,2.04,0,0,0-.839-.123,1.707,1.707,0,0,0-.953.355,2.263,2.263,0,0,0-.61.836c-.138.3-.235.579-.323.813A2.837,2.837,0,0,1,86.981,286.926Z" transform="translate(-86.979 -284.034)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15860" data-name="Group 15860" transform="translate(8.262 18.152)">
                        <g id="Group_15859" data-name="Group 15859">
                          <g id="Group_15858" data-name="Group 15858">
                            <g id="Group_15857" data-name="Group 15857">
                              <path id="Path_20339" data-name="Path 20339" d="M81.01,274.808a.553.553,0,0,1,.21-.082,2.238,2.238,0,0,1,.613-.07,2.544,2.544,0,0,1,2.524,2.687,2.218,2.218,0,0,1-.108.607.554.554,0,0,1-.1.205,5.873,5.873,0,0,0,.093-.814,2.543,2.543,0,0,0-2.419-2.575A5.864,5.864,0,0,0,81.01,274.808Z" transform="translate(-81.01 -274.655)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15864" data-name="Group 15864" transform="translate(8.258 6.462)">
                        <g id="Group_15863" data-name="Group 15863">
                          <g id="Group_15862" data-name="Group 15862">
                            <g id="Group_15861" data-name="Group 15861">
                              <path id="Path_20340" data-name="Path 20340" d="M81,239.095a2.735,2.735,0,0,1,.141.448c.082.291.189.716.31,1.243.243,1.054.525,2.524.731,4.163s.294,3.134.319,4.215c.013.541.014.979.007,1.281a2.675,2.675,0,0,1-.026.469,2.769,2.769,0,0,1-.035-.469c-.014-.329-.033-.759-.056-1.277-.053-1.078-.159-2.566-.363-4.2s-.47-3.1-.684-4.159l-.261-1.252A2.708,2.708,0,0,1,81,239.095Z" transform="translate(-80.998 -239.095)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15868" data-name="Group 15868" transform="translate(2.951 3.389)">
                        <g id="Group_15867" data-name="Group 15867">
                          <g id="Group_15866" data-name="Group 15866">
                            <g id="Group_15865" data-name="Group 15865">
                              <path id="Path_20341" data-name="Path 20341" d="M64.854,229.823a2,2,0,0,1,.688-.075,4.906,4.906,0,0,1,3.094,1.138,1.989,1.989,0,0,1,.475.5,6.1,6.1,0,0,0-4.257-1.566Z" transform="translate(-64.854 -229.748)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15872" data-name="Group 15872" transform="translate(5.007 21.906)">
                        <g id="Group_15871" data-name="Group 15871">
                          <g id="Group_15870" data-name="Group 15870">
                            <g id="Group_15869" data-name="Group 15869">
                              <path id="Path_20342" data-name="Path 20342" d="M71.109,294.042a.935.935,0,0,1,.12.153l.32.45a5.175,5.175,0,0,0,1.545,1.279,5.367,5.367,0,0,0,2.9.533,7.145,7.145,0,0,0,3.39-1.277,8.253,8.253,0,0,0,.711-.56l-.025.058c-.01-2.407-.019-4.55-.026-6.114,0-.759.007-1.376.009-1.824,0-.2.007-.365.01-.493a.764.764,0,0,1,.013-.172.748.748,0,0,1,.016.171l.018.492c.01.448.023,1.065.039,1.824.019,1.564.046,3.707.076,6.114v.038l-.026.02a8.314,8.314,0,0,1-.726.573,7.2,7.2,0,0,1-3.468,1.292,5.408,5.408,0,0,1-2.964-.578,5,5,0,0,1-1.541-1.34c-.135-.2-.231-.363-.3-.471A.9.9,0,0,1,71.109,294.042Z" transform="translate(-71.109 -286.076)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15876" data-name="Group 15876" transform="translate(5.238 27.359)" opacity="0.3">
                        <g id="Group_15875" data-name="Group 15875">
                          <g id="Group_15874" data-name="Group 15874">
                            <g id="Group_15873" data-name="Group 15873">
                              <path id="Path_20343" data-name="Path 20343" d="M84.768,304.765c-1.073.452-2.427.875-2.653,2.018a8.247,8.247,0,0,1-.154,1.145c-.3.872-1.4,1.12-2.321,1.206A11.5,11.5,0,0,1,75,308.85a4.659,4.659,0,0,1-3.193-3.139c1.352.834,1.985,1.789,3.552,2.049a9.44,9.44,0,0,0,3.364-.7,6.108,6.108,0,0,0,1.891-1.42c.074-.293-.008-1.267-.071-.972-.021.1,1.434-.829,2.162-1.1.864-.326,2.06-.9,2.06-.9" transform="translate(-71.81 -302.662)" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15880" data-name="Group 15880" transform="translate(8.693 21.941)" opacity="0.3">
                        <g id="Group_15879" data-name="Group 15879">
                          <g id="Group_15878" data-name="Group 15878">
                            <g id="Group_15877" data-name="Group 15877">
                              <path id="Path_20344" data-name="Path 20344" d="M84.754,286.183c-.234,1.057-.908,2.718-1.262,3.742a1.608,1.608,0,0,1-.25.512.569.569,0,0,1-.5.226.582.582,0,0,1-.421-.644,1.693,1.693,0,0,1,.348-.764l2.084-3.072" transform="translate(-82.319 -286.183)" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15894" data-name="Group 15894" transform="translate(5.538 33.192)">
                      <g id="Group_15885" data-name="Group 15885">
                        <g id="Group_15884" data-name="Group 15884">
                          <g id="Group_15883" data-name="Group 15883">
                            <g id="Group_15882" data-name="Group 15882">
                              <path id="Path_20345" data-name="Path 20345" d="M72.723,322.292a3.369,3.369,0,0,1,.282-.515c.191-.322.469-.778.808-1.327l.028-.044.051.018c.691.251,1.526.54,2.433.818,1.241.383,2.38.675,3.208.875l.982.232a1.7,1.7,0,0,1,.357.1,1.694,1.694,0,0,1-.369-.041c-.236-.037-.575-.1-.994-.184-.836-.173-1.984-.449-3.23-.834-.91-.279-1.745-.578-2.433-.845l.078-.026c-.351.541-.645.988-.854,1.3A3.377,3.377,0,0,1,72.723,322.292Z" transform="translate(-72.722 -320.406)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15889" data-name="Group 15889" transform="translate(7.528 2.213)">
                        <g id="Group_15888" data-name="Group 15888">
                          <g id="Group_15887" data-name="Group 15887">
                            <g id="Group_15886" data-name="Group 15886">
                              <path id="Path_20346" data-name="Path 20346" d="M95.626,329.621a703.24,703.24,0,0,0,.928-2.484,5.675,5.675,0,0,1-.928,2.484Z" transform="translate(-95.622 -327.137)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g id="Group_15893" data-name="Group 15893" transform="translate(0.016 2.097)">
                        <g id="Group_15892" data-name="Group 15892">
                          <g id="Group_15891" data-name="Group 15891">
                            <g id="Group_15890" data-name="Group 15890">
                              <path id="Path_20347" data-name="Path 20347" d="M72.772,326.785c.014-.022.393.209,1.031.531a17.518,17.518,0,0,0,2.579,1.053,18.951,18.951,0,0,0,2.713.639c.706.112,1.148.153,1.146.178a1.231,1.231,0,0,1-.313,0c-.2-.006-.491-.03-.848-.072a15.229,15.229,0,0,1-2.744-.6,14.353,14.353,0,0,1-2.583-1.1c-.315-.174-.563-.326-.729-.44A1.237,1.237,0,0,1,72.772,326.785Z" transform="translate(-72.771 -326.784)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15898" data-name="Group 15898" transform="translate(5.401 35.444)" opacity="0.3">
                      <g id="Group_15897" data-name="Group 15897">
                        <g id="Group_15896" data-name="Group 15896">
                          <g id="Group_15895" data-name="Group 15895">
                            <path id="Path_20348" data-name="Path 20348" d="M79.418,329.484a.4.4,0,0,1-.188.515,1.094,1.094,0,0,1-.593.1,10.567,10.567,0,0,1-6.068-2.215c-.176-.137-.359-.391-.207-.554.128-.137.354-.047.516.048a16.833,16.833,0,0,0,6.734,2.206" transform="translate(-72.306 -327.256)" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15921" data-name="Group 15921" transform="translate(14.046 43.901)">
                  <g id="Group_15910" data-name="Group 15910">
                    <g id="Group_15904" data-name="Group 15904" transform="translate(0 0.071)">
                      <g id="Group_15903" data-name="Group 15903">
                        <g id="Group_15902" data-name="Group 15902">
                          <g id="Group_15901" data-name="Group 15901">
                            <path id="Path_20349" data-name="Path 20349" d="M98.6,279.423l13.533-2.928,2.828-.7,2.232,1.347a1.224,1.224,0,0,1,.58.885l.194,1.445-.272.236.354.653a.819.819,0,0,1-.082.9h0l-2.279-1.714,1.489,2.091a1.3,1.3,0,0,1-.99.236c-.707-.047-2.474-2.469-2.474-2.469l-1.157-.181,2.435,2.62s.111.22-.408.408-3.221-1.895-3.221-1.895l-12.7,6.207" transform="translate(-98.602 -275.794)" fill="#ffceaf" />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Group_15909" data-name="Group 15909">
                      <g id="Group_15908" data-name="Group 15908">
                        <g id="Group_15907" data-name="Group 15907">
                          <g id="Group_15906" data-name="Group 15906">
                            <g id="Group_15905" data-name="Group 15905">
                              <path id="Path_20350" data-name="Path 20350" d="M98.662,286.421a.337.337,0,0,1,.057-.033l.172-.09.675-.341,2.57-1.277,9.2-4.527a.068.068,0,0,1,.07.007c.549.416,1.131.835,1.748,1.231a7.845,7.845,0,0,0,.966.543c.166.065.354.154.491.085a.881.881,0,0,0,.231-.128c.068-.048.1-.131.087-.16l.012.017-2.437-2.618a.076.076,0,0,1,.067-.127l1.157.18a.079.079,0,0,1,.05.031,17.817,17.817,0,0,0,1.436,1.721,3.121,3.121,0,0,0,.875.689,1.346,1.346,0,0,0,1.036-.186l-.008.1-.441-.618-1.049-1.473a.078.078,0,0,1,.11-.107l1.845,1.389.227.171.113.085.057.043.028.021.007.005h0l-.105.013h0l0,0,.01-.013a.744.744,0,0,0,.15-.478,1.022,1.022,0,0,0-.178-.487l-.264-.488a.076.076,0,0,1,.017-.094l.272-.236-.025.067-.177-1.324a1.193,1.193,0,0,0-.637-1l-2.154-1.3.054.008-1.768.435c-.577.142-1.141.286-1.7.4l-3.162.677-5.181,1.1-3.366.708-.894.182-.23.044a.457.457,0,0,1-.079.011.374.374,0,0,1,.076-.023l.228-.055.889-.2,3.357-.747,5.173-1.136,3.159-.69c.557-.114,1.119-.259,1.7-.4l1.766-.44a.073.073,0,0,1,.054.008l2.157,1.3a1.363,1.363,0,0,1,.5.457,1.419,1.419,0,0,1,.211.649q.088.655.178,1.324a.076.076,0,0,1-.025.067l-.272.236.017-.094.265.488a1.174,1.174,0,0,1,.2.554.894.894,0,0,1-.18.577l-.012.016,0,0,0,0-.107.013h0l-.007-.006-.028-.021-.057-.042-.113-.086-.227-.171-1.846-1.388.11-.107,1.049,1.473.441.618,0,.005a.071.071,0,0,1-.012.1,1.177,1.177,0,0,1-.581.241,2.1,2.1,0,0,1-.3.022c-.05,0-.1,0-.151,0a1.468,1.468,0,0,1-.163-.036,3.2,3.2,0,0,1-.934-.727,17.845,17.845,0,0,1-1.449-1.739l.05.031-1.156-.182.067-.127,2.433,2.622,0,0a.032.032,0,0,1,.007.012.3.3,0,0,1-.125.338,1.023,1.023,0,0,1-.27.15.376.376,0,0,1-.166.036.626.626,0,0,1-.158-.024,1.908,1.908,0,0,1-.278-.1,7.914,7.914,0,0,1-.984-.556c-.622-.4-1.2-.823-1.754-1.244l.07.007-9.225,4.477-2.587,1.243-.683.323-.176.081A.3.3,0,0,1,98.662,286.421Z" transform="translate(-98.602 -275.579)" fill="#6f4c47" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15915" data-name="Group 15915" transform="translate(14.207 2.341)">
                    <g id="Group_15914" data-name="Group 15914">
                      <g id="Group_15913" data-name="Group 15913">
                        <g id="Group_15912" data-name="Group 15912">
                          <g id="Group_15911" data-name="Group 15911">
                            <path id="Path_20351" data-name="Path 20351" d="M146.188,286.275a4.873,4.873,0,0,1-.548-.688c-.323-.437-.76-1.048-1.235-1.728a1.5,1.5,0,0,0-.817-.715c-.332-.094-.66-.149-.921-.213a4.909,4.909,0,0,1-.849-.227,4.918,4.918,0,0,1,.871.118c.269.052.582.091.941.184a1.6,1.6,0,0,1,.908.773c.473.677.894,1.294,1.192,1.746A4.931,4.931,0,0,1,146.188,286.275Z" transform="translate(-141.818 -282.699)" fill="#6f4c47" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g id="Group_15920" data-name="Group 15920" transform="translate(14.8 1.241)">
                    <g id="Group_15919" data-name="Group 15919">
                      <g id="Group_15918" data-name="Group 15918">
                        <g id="Group_15917" data-name="Group 15917">
                          <g id="Group_15916" data-name="Group 15916">
                            <path id="Path_20352" data-name="Path 20352" d="M147.855,282.133a6.277,6.277,0,0,1-.525-.591,16.749,16.749,0,0,0-1.313-1.371l-.4-.365-.192-.173-.093-.083c-.013-.01-.036-.034-.042-.035s0,0,0,0l-.026,0c-.3-.036-.6-.03-.845-.037a4.451,4.451,0,0,1-.791-.037,3.631,3.631,0,0,1,.79-.073,6.7,6.7,0,0,1,.87.006l.034.005a.261.261,0,0,1,.055.022.37.37,0,0,1,.054.042l.1.082.2.17.406.365a11.392,11.392,0,0,1,1.292,1.415A2.934,2.934,0,0,1,147.855,282.133Z" transform="translate(-143.623 -279.353)" fill="#6f4c47" />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15935" data-name="Group 15935" transform="translate(28.775 37.339)">
                <g id="Group_15931" data-name="Group 15931">
                  <g id="Group_15930" data-name="Group 15930">
                    <g id="Group_15929" data-name="Group 15929">
                      <g id="Group_15928" data-name="Group 15928">
                        <g id="Group_15924" data-name="Group 15924" transform="translate(0.081 0.083)">
                          <g id="Group_15923" data-name="Group 15923">
                            <path id="Path_20353" data-name="Path 20353" d="M162.487,271.322l4.741-13.091a1.711,1.711,0,0,0-1.583-2.36H151.638a1.711,1.711,0,0,0-1.62,1.161l-4.479,13.2-7.8.025c-.425,0-.791.568-.791.993h2.564l5.781-.011Z" transform="translate(-136.952 -255.871)" fill="#e0e0e0" />
                          </g>
                        </g>
                        <g id="Group_15927" data-name="Group 15927">
                          <g id="Group_15926" data-name="Group 15926">
                            <g id="Group_15925" data-name="Group 15925">
                              <path id="Path_20354" data-name="Path 20354" d="M162.323,271.152s-.038,0-.118,0l-.356,0-1.391,0h-5.254l-8.086-.016c-3.107-.017-6.574.019-10.332.014h-.081v-.079a1.2,1.2,0,0,1,.156-.552,1.12,1.12,0,0,1,.393-.426.617.617,0,0,1,.295-.093c.1,0,.185,0,.279,0l.555,0,2.265-.009,4.722-.017-.08.057,2.029-5.984,1.349-3.973.66-1.945.326-.961c.057-.16.1-.316.171-.482a1.769,1.769,0,0,1,.279-.445,1.8,1.8,0,0,1,.867-.558,1.843,1.843,0,0,1,.512-.072h2.44l3.77,0,6.97.008h.811a1.78,1.78,0,0,1,1.743,1.428,1.7,1.7,0,0,1-.017.775c-.073.249-.164.474-.246.7l-.489,1.342-3.026,8.266-.826,2.237-.217.578c-.049.13-.077.192-.077.192s.021-.072.067-.206l.206-.591.8-2.258,2.962-8.269.481-1.338c.08-.228.172-.46.237-.687a1.578,1.578,0,0,0,.013-.717,1.662,1.662,0,0,0-.875-1.141,3.4,3.4,0,0,0-1.549-.173l-6.97.008-3.77,0H151.98a3.479,3.479,0,0,0-.958.066,1.635,1.635,0,0,0-.785.507,1.594,1.594,0,0,0-.252.4c-.06.144-.11.311-.165.468l-.326.961-.659,1.945-1.347,3.974-2.031,5.984-.019.057h-.061l-4.722.013-2.265.006h-.555c-.09,0-.188,0-.272,0a.462.462,0,0,0-.222.071,1.072,1.072,0,0,0-.472.84l-.079-.079c3.753.012,7.234-.016,10.323.012l8.061.059,5.26.048,1.4.017.363.007C162.28,271.149,162.323,271.152,162.323,271.152Z" transform="translate(-136.707 -255.618)" fill="#263238" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15934" data-name="Group 15934" transform="translate(9.427 0.128)">
                  <g id="Group_15933" data-name="Group 15933">
                    <g id="Group_15932" data-name="Group 15932">
                      <path id="Path_20355" data-name="Path 20355" d="M170.841,256.007a.608.608,0,0,1-.039.16l-.144.448-.559,1.639c-.479,1.382-1.152,3.286-1.905,5.386s-1.445,4-1.953,5.37l-.61,1.621-.174.438a.588.588,0,0,1-.072.149.619.619,0,0,1,.039-.16l.144-.448.559-1.639c.479-1.381,1.152-3.286,1.905-5.386s1.444-4,1.953-5.369l.61-1.621.174-.438A.6.6,0,0,1,170.841,256.007Z" transform="translate(-165.384 -256.007)" fill="#263238" />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group_15953" data-name="Group 15953" transform="translate(24.745 52.804)">
                <g id="Group_15939" data-name="Group 15939">
                  <g id="Group_15938" data-name="Group 15938">
                    <g id="Group_15937" data-name="Group 15937">
                      <g id="Group_15936" data-name="Group 15936">
                        <path id="Path_20356" data-name="Path 20356" d="M125.641,305.049h44.13a1.193,1.193,0,0,0,1.193-1.193h0a1.193,1.193,0,0,0-1.193-1.193h-44.13a1.193,1.193,0,0,0-1.193,1.193h0A1.193,1.193,0,0,0,125.641,305.049Z" transform="translate(-124.448 -302.662)" fill="#455a64" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15943" data-name="Group 15943" transform="translate(21.726 1.939)">
                  <g id="Group_15942" data-name="Group 15942" transform="translate(0 0)">
                    <g id="Group_15941" data-name="Group 15941">
                      <g id="Group_15940" data-name="Group 15940">
                        <rect id="Rectangle_18388" data-name="Rectangle 18388" width="3.85" height="49.32" transform="translate(3.85 49.32) rotate(180)" fill="#455a64" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15947" data-name="Group 15947" transform="translate(10.451 48.316)">
                  <g id="Group_15946" data-name="Group 15946">
                    <g id="Group_15945" data-name="Group 15945">
                      <g id="Group_15944" data-name="Group 15944">
                        <path id="Path_20357" data-name="Path 20357" d="M182.429,452.58H156.24c.171,0,11.274-2.944,11.274-2.944h3.85Z" transform="translate(-156.24 -449.636)" fill="#455a64" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group_15952" data-name="Group 15952" transform="translate(1.078 2.207)">
                  <g id="Group_15951" data-name="Group 15951">
                    <g id="Group_15950" data-name="Group 15950">
                      <g id="Group_15949" data-name="Group 15949">
                        <g id="Group_15948" data-name="Group 15948">
                          <path id="Path_20358" data-name="Path 20358" d="M127.727,309.454c0-.043,9.979-.078,22.286-.078s22.288.035,22.288.078-9.977.078-22.288.078S127.727,309.5,127.727,309.454Z" transform="translate(-127.727 -309.376)" fill="#263238" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
